// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:29:21.237Z
// Property: The Mason (ID: 5675057267343360)
// Collections: 20 amenities, 9 floorplans (live), 23 photos, 79 POIs, 3 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5675057267343360",
  "property_external_id": "4786612",
  "property_zillow_url": "https://www.zillow.com/apartments/ladson-sc/the-mason/Bb8gvr/",
  "property_apartments_url": "https://www.apartments.com/the-mason-ladson-sc/z0v0vpw",
  "property_google_business_url": "https://www.google.com/maps/place/The+Mason/@32.999284,-80.1208437,17z/data=!4m13!1m7!3m6!1s0x88fe8a6044f8c3af:0xf90e3c177ea0def3!2s1110+Mason+Pond+Pl,+Ladson,+SC+29456!3b1!8m2!3d32.999284!4d-80.1186497!3m4!1s0x88fe8a6042c967bf:0x557edf23aa1328e1!8m2!3d32.9993127!4d-80.1185846",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443209788",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-mason",
  "property_name": "The Mason",
  "property_website_url": "https://www.themasonsc.com/",
  "property_domain": "https://www.themasonsc.com/",
  "property_address": "1110 Mason Pond Pl",
  "property_full_address": "1110 Mason Pond Pl, Ladson, SC 29456",
  "property_address_1": "1110 Mason Pond Pl",
  "property_address_2": null,
  "property_address_city": "Ladson",
  "property_address_state": "SC",
  "property_address_zip_full": "29456-4269",
  "property_address_zip": "29456",
  "property_address_country": "US",
  "property_address_county": "Charleston County",
  "property_neighborhood_address": "Summerville",
  "property_address_latitude": "32.9992435",
  "property_address_longitude": "-80.11861189999999",
  "property_email": "mason@alapts.com",
  "property_phone": "(843) 608-0138",
  "property_call_tracking_phone": "854-231-4812",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Suburban ease with polished Lowcountry style.</strong> The Mason pairs studio to three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with elevated everyday finishes, relaxed community spaces, and a quieter Ladson setting near I-26 and US-78—close to Summerville energy and Charleston access.</p>",
  "property_long_description": "<p><strong>Suburban ease with a polished Lowcountry feel.</strong> At The Mason, you’re close to Summerville energy and Charleston access while coming home to a quieter Ladson setting near I-26 and US-78. Choose from studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with the everyday finishes that make home feel complete: stainless steel appliances, granite countertops, in-home washer and dryer, walk-in closets, ceiling fans, and a private balcony or patio in select homes.</p><p>Beyond your front door, the community is built for easy routines and relaxed downtime. Start the day in the fitness center, settle in by the resort-style pool and cabanas, meet up in the clubhouse, or enjoy the pond, courtyard, grilling areas, walking and biking trails, package service, pet play area, and car wash station. Explore more <a href=\"/amenities\">amenities</a>, then head out to Exchange Park, Charleston Southern University, Trident Medical Center, Azalea Square, Nexton dining, or downtown Summerville’s shops, restaurants, and Azalea Park—all within a convenient Lowcountry radius.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019d02f0-c92b-764f-bb71-2ed4fa4f4a66.webp",
  "property_featured_image_media": {
    "alt_text": "Modern dining area and kitchen with island.",
    "public_id": "019d02f0-c92b-764f-bb71-2ed4fa4f4a66",
    "storage_key": "property/5675057267343360/019d02f0-c92b-764f-bb71-2ed4fa4f4a66.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "264",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.5909090909091",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $375 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $599\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "375",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $375 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $375 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8689922.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://themasonsc.loftliving.com/login",
  "property_apply_now_url": "https://8689922.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e73f1-0624-73ae-88f0-9e456457087f.webp",
  "property_primary_logo_media": {
    "alt_text": "The Mason logo",
    "public_id": "019e73f1-0624-73ae-88f0-9e456457087f",
    "storage_key": "property/5675057267343360/019e73f1-0624-73ae-88f0-9e456457087f.webp",
    "width": 1155,
    "height": 692
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e73f1-0623-75c3-bad3-2d09b6bc19c1.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Mason logo with tagline 'Love Coming Home' and location 'South Carolina'.",
    "public_id": "019e73f1-0623-75c3-bad3-2d09b6bc19c1",
    "storage_key": "property/5675057267343360/019e73f1-0623-75c3-bad3-2d09b6bc19c1.webp",
    "width": 1292,
    "height": 994
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e73f1-07ae-726c-b366-fc1e191af90d.webp",
  "property_icon_media": {
    "alt_text": "Stylized blue spiral logo on a black background.",
    "public_id": "019e73f1-07ae-726c-b366-fc1e191af90d",
    "storage_key": "property/5675057267343360/019e73f1-07ae-726c-b366-fc1e191af90d.webp",
    "width": 370,
    "height": 370
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e73f1-07ae-726c-b366-fc1e191af90d.webp",
  "property_fav_icon_media": {
    "alt_text": "Stylized blue spiral logo on a black background.",
    "public_id": "019e73f1-07ae-726c-b366-fc1e191af90d",
    "storage_key": "property/5675057267343360/019e73f1-07ae-726c-b366-fc1e191af90d.webp",
    "width": 370,
    "height": 370
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e73f1-0819-714b-9680-996003a913a7.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Mason logo with a circular abstract design above the words \"THE MASON\".",
    "public_id": "019e73f1-0819-714b-9680-996003a913a7",
    "storage_key": "property/5675057267343360/019e73f1-0819-714b-9680-996003a913a7.webp",
    "width": 1155,
    "height": 692
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e73f1-0623-75c3-bad3-33939e1f6337.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Mason logo",
    "public_id": "019e73f1-0623-75c3-bad3-33939e1f6337",
    "storage_key": "property/5675057267343360/019e73f1-0623-75c3-bad3-33939e1f6337.webp",
    "width": 1155,
    "height": 692
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#0a3b61",
  "property_secondary_color": "#e0b11e",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "603 - 1331",
  "property_sqft_min": "603",
  "property_sqft_max": "1331",
  "property_price_range": "1393.5 - 2467.5",
  "property_price_min": "1393.5",
  "property_price_max": "2467.5",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/themasonsc",
  "property_instagram_url": "https://www.instagram.com/themasonsc",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJv2fJQmCK_ogR4SgTqiPfflU",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-mason-ladson-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenity-rich living, made easy.</strong> At The Mason, polished apartment finishes pair with spaces built for downtime—think a 24/7 fitness center, pool with cabanas, clubhouse, game room, movie theater, and outdoor gathering areas. Daily details are covered too, from package service and door-to-door trash pickup to a car wash area, Wi-Fi, and pet-friendly perks including a play area.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that fits your everyday.</strong> The Mason offers studio, one-, two-, and three-bedroom apartments in Ladson with open living areas, smart kitchens, in-home washer and dryer, and generous storage. Select homes add granite countertops, stainless steel appliances, kitchen islands or pantries, walk-in closets, double vanities, vinyl flooring, and a balcony or patio—so every floor plan brings its own standout perks.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a feel for The Mason in photos.</strong> Preview bright, open interiors with granite countertops, stainless steel appliances, kitchen islands, and flexible living space. Then picture the outdoor scene: pool deck, cabanas, clubhouse, game spaces, movie room, courtyard, and pond views—all waiting in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lowcountry charm, close to everything.</strong> From The Mason, coffee in Nexton, dinner in Summerville, and strolls near Hutchinson Square are all within easy reach. Browse the Summerville Farmers Market, hit the Sawmill Branch Trail, or spot local icons like the Summerville Arch and sweet-tea landmark—then come home to a tucked-away Ladson setting with Charleston-area connections nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about life at The Mason.</strong> Reviews call out spacious modern apartments, polished grounds, and a pool area described as “picturesque.” Friendly leasing service, responsive maintenance, a well-equipped gym, weekly food trucks, and a clean, resort-inspired atmosphere all earn standout praise. See why The Mason is described as “fresh,” welcoming, and “a very nice place to call home.”</p>",
  "property_neighborhood_blurb": "<p><strong>Find your Lowcountry rhythm just beyond the map.</strong> From The Mason, everyday errands and weekend plans spread out in every direction—coffee in Nexton, dinner around Summerville’s growing dining scene, or a downtown stroll near Hutchinson Square. Spend Saturday browsing the Summerville Farmers Market, follow the paved Sawmill Branch Trail when you want fresh air, or look for local character in details like the Summerville Arch and the town’s famous sweet-tea landmark.</p><p>Back in Ladson, you’re positioned for an easy hop between Summerville favorites and Charleston-area destinations, with the calm of a tucked-away apartment community waiting at day’s end. Explore the nearby highlights on the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Mason connects home, convenience, and Lowcountry charm.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everything you need for smoother days and better downtime.</strong> At The Mason, amenities are designed to move with you—from a 24/7 fitness center and pool with cabanas to a clubhouse, game room, movie theater, and outdoor gathering spaces that make staying in feel like a plan.</p><p>Everyday convenience is built in, too, with package service, on-site management and maintenance, door-to-door trash pickup, Wi-Fi, a car wash area, and pet-friendly perks including a play area. Inside your apartment, granite countertops, stainless steel appliances, an in-home washer and dryer, walk-in closets, and a private balcony or patio in select layouts bring polish to the practical. Browse the <a href=\"/gallery\">amenity photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Mason supports your routine.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Mason home?</strong> Start your application online for a polished Ladson apartment with studio, one-, two-, and three-bedroom layouts, stainless steel appliances, granite countertops, in-home washer and dryer, and easy access to relaxed community spaces—all close to Summerville energy and Charleston access.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact The Mason leasing team for details on studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a>, polished apartment finishes, community features, or directions to our quieter Ladson setting near I-26 and US-78.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Mason?</strong> Start here for quick answers about the community, leasing, apartment layouts, features, and everyday living in Ladson. If you don’t see what you need, the leasing team is happy to help with details, availability, or next steps.</p>",
  "property_floorplans_blurb": "<p><strong>Compare layouts that make the most of every room.</strong> At The Mason, you can choose from streamlined studio apartments, flexible one-bedroom homes, roomy two-bedroom layouts, and a three-bedroom option with space to spread out in Ladson. Open living areas, well-planned kitchens, in-home washer and dryer, and generous storage help each floor plan feel practical from day one.</p><p>As you browse current availability, look for details that elevate the everyday: granite countertops, stainless steel appliances, island or pantry kitchens in select layouts, walk-in closets, double vanities, vinyl flooring, and a balcony or patio with select homes. Check the cards below for pricing and availability, then explore <a href=\"/gallery\">photos of the apartments</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces from every angle.</strong> Browse photos of The Mason and get a closer look at the finishes, light, and outdoor moments that shape daily life here in Ladson. Picture an open kitchen with granite countertops, stainless steel appliances, and an island made for easy prep; then move into living areas with clean lines, natural light, and room to make the layout your own.</p><p>Outside, the gallery follows the scene from the pool deck and cabanas to the clubhouse, game spaces, movie room, courtyard, and pond views. As you explore, compare the look and feel of each space with the full <a href=\"/amenities\">amenities</a> list, view available <a href=\"/floor-plans\">floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Mason in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Mason from every angle.</strong> Use the interactive map to browse available apartments, see where each home sits, and get a feel for the Ladson location near I-26, US-78, Summerville energy, and Charleston access.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living should feel effortless, not like an afterthought.</strong> At The Mason, cats and dogs have everyday perks built into the community, from a dedicated pet play area and dog park to walking and biking trails for leashed strolls in Ladson. Green spaces around the courtyard and pond make it easy to step outside for fresh air, while in-home washer and dryer, storage space, and balcony or patio options help keep daily routines simple.</p><p>Up to two pets are welcome per apartment, with no weight limit; breed restrictions may apply, and the leasing team can walk you through the details. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the community spaces firsthand.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Lowcountry ease you love.</strong> Invite a friend to discover The Mason’s quieter Ladson setting, polished apartment finishes, and relaxed spaces for everyday downtime—then let them see why coming home here feels so complete.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>From your quieter Ladson setting at The Mason, manage everyday routines in just a few clicks. Pay rent, submit maintenance requests, and keep your account up to date—so home stays as polished and easy as it should.</p>",
  "property_reviews_blurb": "<p><strong>See why residents love coming home to The Mason.</strong> Reviews highlight a community that feels polished, comfortable, and cared for—from spacious, modern apartments to beautifully maintained grounds and a pool area residents call “picturesque.” You’ll see frequent praise for the friendly leasing team, quick maintenance responses, and thoughtful extras like the gym, weekly food trucks, and welcoming atmosphere.</p><p>Residents describe The Mason as “clean, fresh,” “resort” inspired, and “a very nice place to call home.” Read the reviews below to hear firsthand what makes everyday living here stand out.</p>",
  "property_created_at": "1752256475368",
  "property_scheduletour_blurb": "<p><strong>See The Mason in person.</strong><br>Tour a polished Lowcountry apartment community with studio to three-bedroom layouts, stainless steel appliances, granite countertops, in-home laundry, and relaxed spaces from the resort-style pool to the clubhouse. Schedule your tour and picture the ease of coming home in Ladson.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> Your inquiry has been received, and The Mason leasing team will follow up soon. In the meantime, picture polished Lowcountry living with studio to three-bedroom layouts, refined home finishes, and easygoing spaces made for everyday comfort in a quieter Ladson setting.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through The Mason before you arrive.</strong> Start with a full community virtual tour, then step inside the two-bedroom, two-bath apartment walkthrough to get a better feel for the flow, finishes, and everyday livability. From there, explore the spaces that shape downtime at home: the fitness center, clubhouse, movie theater room, and 360-degree pool view. Each tour lets you slow down, look around, and compare the details that matter most before planning your visit to Ladson. Browse the walkthroughs below, then check current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see The Mason in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Mason",
  "property_seo_title_home": "The Mason | Apartments in Ladson, SC",
  "property_seo_description_home": "Discover your perfect home at The Mason in Ladson, SC! Explore our diverse floor plans, including stylish studios and spacious one, two, and three-bedroom apartments designed for your comfort. Enjoy premium amenities like a state-of-the-art fitness center, a refreshing pool, and convenient LUXER package lockers. With pet-friendly spaces, modern kitchens featuring islands, and luxurious garden tubs, each apartment offers a blend of comfort and style. Join our welcoming community today and experience the ultimate in apartment living. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | studio - 3 Apartments in Ladson, SC",
  "property_seo_description_floorplans": "Discover your ideal living space at The Mason in Ladson, SC! Explore our diverse range of floor plans, including stylish studios, spacious one, two, and three-bedroom apartments. Each layout is designed for comfort and convenience. Browse our available apartment homes today and find the perfect floor plan that suits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Ladson, SC Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at The Mason in Ladson, SC! Our community offers spacious floor plans, including studio, one, two, and three-bedroom apartments. Enjoy top-notch amenities like a dog park, fitness center, and resort-style pool. With features such as smart locks, large walk-in closets, and online resident services, life at The Mason is designed for your comfort and convenience. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Ladson, SC",
  "property_seo_description_gallery": "\"Explore The Mason, your ideal apartment community in Ladson, SC! Choose from expertly designed floor plans including studios, one, two, and three-bedroom apartments. Enjoy exceptional amenities like a refreshing pool, fitness center, and dog park. Discover features such as smart locks, walk-in closets, and stylish kitchen islands. Don't just imagine your life here—picture it by browsing our stunning photo gallery! Schedule your visit today and make The Mason your new home!\"",
  "property_seo_title_virtualtours": "Virtual Tours | The Mason Apartments",
  "property_seo_description_virtualtours": "Explore The Mason in Ladson, SC! Take a virtual tour of our stunning apartment community featuring spacious one, two, and three-bedroom layouts, as well as modern studios. Discover your perfect home today—view all our floor plans and experience the lifestyle you've been dreaming of! Don't miss your chance; take a virtual tour now!",
  "property_seo_title_interactivemap": "Interactive Map | The Mason Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at The Mason in Ladson, SC! Explore our diverse floor plans, including studios, one, two, and three-bedroom apartments, each designed to meet your lifestyle needs. Enjoy top-notch amenities like a state-of-the-art fitness center, dog park, and luxurious garden tubs. With our LUXER Package Locker and smart home features, convenience is just a click away. Use our interactive community map to explore available apartments, view pricing, and select your new home today! Find your ideal living space at The Mason—where comfort meets community.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Ladson, SC",
  "property_seo_description_neighborhood": "Discover The Mason in Ladson, SC! Explore our vibrant neighborhood and see what’s around our community. From local favorites to nearby points of interest, there's something for everyone. Check out our spacious floor plans—choose from studio, one, two, or even three-bedroom options. Dive into the exciting lifestyle that awaits you at The Mason today! ",
  "property_seo_title_contact": "Contact Us | The Mason",
  "property_seo_description_contact": "Discover your perfect home at The Mason in Ladson, SC! Explore our diverse range of floor plans, including one-bedroom, two-bedroom, three-bedroom, and studio apartments. Have questions? Contact our leasing team today for personalized assistance and find out why The Mason is the ideal place for you!",
  "property_seo_title_faqs": "FAQs | Apartments in Ladson, SC",
  "property_seo_description_faqs": "Discover everything you need to know about The Mason, your ideal apartment community in Ladson, SC! Explore our range of floor plans, including one, two, and three-bedroom options, as well as stylish studios. Dive into our rich array of amenities, such as a state-of-the-art fitness center, refreshing pool, dog park, and the convenience of smart locks and package lockers. Whether you’re interested in online resident services or enjoying outdoor spaces with an outdoor fireplace, we have it all. Browse our FAQs page to find answers to your questions and learn why The Mason is the perfect place to call home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Ladson, SC",
  "property_seo_description_reviews": "Discover what makes The Mason in Ladson, SC, a standout choice for your next home! Explore our stunning one, two, and three-bedroom floor plans, as well as stylish studios, all featuring top-notch amenities like a state-of-the-art fitness center, relaxing pool, and dog park. From spacious walk-in closets and modern kitchen appliances to smart locks and online resident services, we have everything you need for comfortable living. Don’t just take our word for it—see what our residents have to say about living in this vibrant community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Ladson, SC",
  "property_seo_description_applynow": "\"Discover modern living at The Mason in Ladson, SC. Choose from spacious one, two, and three-bedroom apartments or cozy studios featuring top-notch amenities like a dog park, fitness center, and inviting pool. Enjoy perks like smart locks, W&D included, and online resident services. Explore our beautiful floor plans and find your perfect home today. Apply now and lease online to experience the best in apartment living!\"",
  "property_seo_title_residentaccess": "Resident Access | The Mason",
  "property_seo_description_residentaccess": "\"Welcome to The Mason in Ladson, SC! Access your resident portal now to conveniently pay rent, schedule maintenance, and manage your apartment life all in one place. Experience hassle-free living—log in today!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Mason",
  "property_seo_description_referafriend": "\"Discover the perfect living experience at The Mason in Ladson, SC! Refer a friend today and enjoy exclusive perks together. Great friends make great neighbors—invite them to join our vibrant community!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Mason",
  "property_seo_description_scheduletour": "\"Discover your dream home at The Mason in Ladson, SC! Explore our vibrant apartment community and experience unmatched amenities. Schedule a tour today and see why The Mason is the perfect place for you!\"",
  "property_seo_title_privacy": "Privacy Policy | The Mason",
  "property_seo_description_privacy": "\"Discover The Mason in Ladson, SC, where your privacy matters! Our comprehensive privacy policy highlights how we protect your information while you find your perfect home. Trust us to keep your data safe—view our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | The Mason",
  "property_seo_description_accessibility": "Discover The Mason's commitment to digital inclusion in Ladson, SC! Our accessibility statement highlights our dedication to providing an inclusive online experience for all. Explore how we’re making living easier for everyone. Join us today and experience the difference!",
  "property_seo_title_sitemap": "Sitemap | The Mason",
  "property_seo_description_sitemap": "Discover all that The Mason in Ladson, SC, has to offer! Explore our comprehensive sitemap to easily navigate amenities, floor plans, and community features. Start your journey to your new home today—view our website sitemap now!",
  "property_seo_title_thankyou": "Thank You | The Mason",
  "property_seo_description_thankyou": "Thank you for your interest in The Mason in Ladson, SC! A member of our team will reach out to you shortly with all the details you need about your new home. Stay tuned for exciting updates and personalized assistance to make your apartment search seamless!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651138676",
  "amenities": [
    {
      "id": "custom_accc00f8-87cc-479c-b406-65ef6827cddd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a03dbdbc-2930-4dce-9f3e-4abdc0c40e16",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c666f80-203e-4735-848b-9e032654767a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91ed722e-06ef-495d-bebe-b01ee70dca9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Gourmet Kitchens w/Island*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e12c69b-142c-453b-95c5-13d9cf61d869",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Tubs*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64873483-30c4-4c97-a062-3be38b75b151",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_294bb2ee-2d2f-442a-959a-324132e0734e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Attached & Detached Garages Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_365bc9a6-3fde-4745-9b41-95e3f24accd9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Inspired Plank Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_115e561e-c835-4cb9-8386-3a33e10f079f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a90782e8-707c-4c3c-9ec2-7ef51da5fe2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db5d6a33-4c33-49e0-aa22-030b05bd5547",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ecfb2de-5813-4cba-98a9-47d97da24324",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/ Outdoor Cabanas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b89e6d2e-7111-47fa-892c-fbcc7a4264ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000659",
      "title": "On Demand Fitness",
      "amount": "0.0000",
      "description": "Virtual Fitness-On-Demand, Yoga & Spin Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_637b31c5-58c8-4441-af41-5748e804241b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000002464",
      "title": "Outdoor Fireplace",
      "amount": "0.0000",
      "description": "Outdoor Fireplace, Grilling Areas & Cornhole Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4138925c-68b0-49ef-b353-297f054074ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1f7dcdb-4c97-4de1-b5f9-b288290b8be3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Spacious Clubhouse w/Coffee Bar & Media Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f937d31-9e3b-455d-976a-cf6d5c29024f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23c65620-ab5e-43e7-9c71-8f7b743e6645",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ed10e11-ec1d-4478-b350-2a56b6bec2f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d10a9706-c4bb-4451-a68c-466bab0150fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1605bdfe-cb6a-44e2-92eb-db206262de49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-5e77-76a3-9410-1029c2d15c5a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, granite countertop, white sink, toilet, and bathtub with shower.",
        "public_id": "019e8a04-5e77-76a3-9410-1029c2d15c5a",
        "storage_key": "property/5675057267343360/019e8a04-5e77-76a3-9410-1029c2d15c5a.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our modern bathrooms, featuring elegant granite countertops, spacious vanities, and pristine white fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with gray vanity, granite countertop, white sink, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f67dc6a8-f07e-4b67-881b-b4aaab2930ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-5fda-721c-9277-0adbb756a598.webp",
      "image_media": {
        "alt_text": "Community lounge with shuffleboard, foosball, and seating areas.",
        "public_id": "019e8a04-5fda-721c-9277-0adbb756a598",
        "storage_key": "property/5675057267343360/019e8a04-5fda-721c-9277-0adbb756a598.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge featuring shuffleboard, foosball, and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge with shuffleboard, foosball, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc8321ac-dd80-4f2f-bb28-15e3384d81cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-5c7f-75d8-8c25-e96217e0fe22.webp",
      "image_media": {
        "alt_text": "Balcony with outdoor furniture overlooking community amenities like a playground and apartment buildings.",
        "public_id": "019e8a04-5c7f-75d8-8c25-e96217e0fe22",
        "storage_key": "property/5675057267343360/019e8a04-5c7f-75d8-8c25-e96217e0fe22.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Community",
      "description": "Enjoy the fresh air and beautiful views from your private balcony, offering a comfortable seating area and overlooking the community's playground and resort-style apartment buildings.",
      "link": "",
      "alt_text": "Balcony with outdoor furniture overlooking community amenities like a playground and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ae35fe6-82e5-483c-800e-b76f2ced71d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-58e7-7538-8314-eca1aa75b427.webp",
      "image_media": {
        "alt_text": "Outdoor fitness equipment and playground at apartment complex.",
        "public_id": "019e8a04-58e7-7538-8314-eca1aa75b427",
        "storage_key": "property/5675057267343360/019e8a04-58e7-7538-8314-eca1aa75b427.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active with our on-site outdoor fitness equipment and enjoy the playground for family fun. Part of the vibrant community amenities.",
      "link": "",
      "alt_text": "Outdoor fitness equipment and playground at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6db5f1eb-d00c-42ce-a11a-7c25f61b238c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-5739-71ad-9c9e-ea639805ac3b.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a canopy bed, bedside tables, and a dresser.",
        "public_id": "019e8a04-5739-71ad-9c9e-ea639805ac3b",
        "storage_key": "property/5675057267343360/019e8a04-5739-71ad-9c9e-ea639805ac3b.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Discover a beautifully designed bedroom featuring a modern canopy bed, elegant bedside tables, and a classic wooden dresser, creating a serene and inviting space.",
      "link": "",
      "alt_text": "Stylish bedroom with a canopy bed, bedside tables, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf44706d-d58c-4bc3-b6de-b8d1bb4578b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-4d43-7029-b826-5049044518fc.webp",
      "image_media": {
        "alt_text": "A modern gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e8a04-4d43-7029-b826-5049044518fc",
        "storage_key": "property/5675057267343360/019e8a04-4d43-7029-b826-5049044518fc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weight-lifting equipment, and free weights for a complete workout.",
      "link": "",
      "alt_text": "A modern gym with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b864816-6b87-4a4f-a9e7-4a6a19e246ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-4ff7-707c-a3c0-5094d0adb7eb.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas at a multifamily property.",
        "public_id": "019e8a04-4ff7-707c-a3c0-5094d0adb7eb",
        "storage_key": "property/5675057267343360/019e8a04-4ff7-707c-a3c0-5094d0adb7eb.webp",
        "width": 2714,
        "height": 1808
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip or relax by the sparkling resort-style pool, surrounded by lush landscaping and comfortable seating areas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f84bbe9c-b8bf-429c-b223-215b0501ace0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-4e4e-723e-93e4-38069ee91ca6.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, dining table, and kitchen in the background.",
        "public_id": "019e8a04-4e4e-723e-93e4-38069ee91ca6",
        "storage_key": "property/5675057267343360/019e8a04-4e4e-723e-93e4-38069ee91ca6.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed living area featuring a modern TV console, a round coffee table, and a dining area adjacent to a sleek kitchen.",
      "link": "",
      "alt_text": "Living room with a TV, coffee table, dining table, and kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9af13f8-24dd-42ea-acd6-b785d05e2a62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-490d-7138-854d-a5c17bfafd68.webp",
      "image_media": {
        "alt_text": "Resort-style pool with outdoor fire pit seating area and palm trees",
        "public_id": "019e8a04-490d-7138-854d-a5c17bfafd68",
        "storage_key": "property/5675057267343360/019e8a04-490d-7138-854d-a5c17bfafd68.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax by the resort-style pool or gather around the outdoor fire pit with friends and family. Enjoy the beautiful weather and stunning views.",
      "link": "",
      "alt_text": "Resort-style pool with outdoor fire pit seating area and palm trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99e4d29d-0c78-4023-a819-1e63273fc4be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-4787-71a9-ba8f-ef465a16fe34.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with granite countertops and stainless steel appliances.",
        "public_id": "019e8a04-4787-71a9-ba8f-ef465a16fe34",
        "storage_key": "property/5675057267343360/019e8a04-4787-71a9-ba8f-ef465a16fe34.webp",
        "width": 2363,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this modern apartment featuring a stylish dining area and a fully equipped kitchen with granite countertops and stainless steel appliances.",
      "link": "",
      "alt_text": "Dining area and kitchen with granite countertops and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b039ae9d-ed0b-4682-8be3-7484a56468f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-492a-76ee-81f5-e15cc00e286e.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop and bar stools, adjacent to gray cabinetry, stainless steel appliances, and dining area.",
        "public_id": "019e8a04-492a-76ee-81f5-e15cc00e286e",
        "storage_key": "property/5675057267343360/019e8a04-492a-76ee-81f5-e15cc00e286e.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large granite-topped island with bar stools, sleek gray cabinets, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertop and bar stools, adjacent to gray cabinetry, stainless steel appliances, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da0de902-e779-494c-be7b-ca397e22492e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-4714-746e-aad9-42383a39a00e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with submerged lounge chairs and palm trees.",
        "public_id": "019e8a04-4714-746e-aad9-42383a39a00e",
        "storage_key": "property/5675057267343360/019e8a04-4714-746e-aad9-42383a39a00e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, featuring submerged lounge chairs perfect for soaking up the sun. Surrounded by lush landscaping and modern apartment buildings, it's the ideal spot for relaxation and entertainment.",
      "link": "",
      "alt_text": "Resort-style swimming pool with submerged lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_80c787c4-5590-4b77-a653-276f939fd5d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-3cba-723b-b282-2d18cff113f0.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with pergolas and lounge chairs.",
        "public_id": "019e8a04-3cba-723b-b282-2d18cff113f0",
        "storage_key": "property/5675057267343360/019e8a04-3cba-723b-b282-2d18cff113f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in style in our outdoor lounge area, featuring private pergolas and comfortable lounge chairs. Perfect for soaking up the sun or enjoying a quiet afternoon.",
      "link": "",
      "alt_text": "Outdoor lounge area with pergolas and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f0f7825-0e7c-464c-8ebb-193f4d5cafe1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-3c44-7557-845b-6e2259a1e3e8.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and cabanas.",
        "public_id": "019e8a04-3c44-7557-845b-6e2259a1e3e8",
        "storage_key": "property/5675057267343360/019e8a04-3c44-7557-845b-6e2259a1e3e8.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind at our stunning resort-style pool, complete with ample lounge seating, shaded cabanas, and an outdoor grilling area. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b30ba3ea-d73a-44f4-8ab5-baa72c97538f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-420c-76bb-83ee-d5970747a69e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, shower, and walk-in closet.",
        "public_id": "019e8a04-420c-76bb-83ee-d5970747a69e",
        "storage_key": "property/5675057267343360/019e8a04-420c-76bb-83ee-d5970747a69e.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a granite-top vanity, a toilet, and a shower with a chic curtain. Adjacent is a spacious walk-in closet with ample shelving and hanging space.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, shower, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c2034a8-ac71-4ae4-be96-f0c316bdce74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-35e5-777f-b2f2-3f2e8dd4adcf.webp",
      "image_media": {
        "alt_text": "Community movie theater with a large screen, projector, sound system, and comfortable seating.",
        "public_id": "019e8a04-35e5-777f-b2f2-3f2e8dd4adcf",
        "storage_key": "property/5675057267343360/019e8a04-35e5-777f-b2f2-3f2e8dd4adcf.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Community",
      "description": "Enjoy movie nights in our state-of-the-art community theater, complete with a large screen, immersive sound, and plush seating for ultimate relaxation.",
      "link": "",
      "alt_text": "Community movie theater with a large screen, projector, sound system, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08afc4e8-0074-4b81-896e-41371b7b22fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-34a7-7203-b3f2-8ab17d6fcf45.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a playground and outdoor fitness equipment in a green courtyard.",
        "public_id": "019e8a04-34a7-7203-b3f2-8ab17d6fcf45",
        "storage_key": "property/5675057267343360/019e8a04-34a7-7203-b3f2-8ab17d6fcf45.webp",
        "width": 2732,
        "height": 1820
      },
      "title": "Community",
      "description": "Enjoy the outdoors with a children's playground and an adult fitness area, all set within beautifully landscaped courtyards.",
      "link": "",
      "alt_text": "Apartment buildings with a playground and outdoor fitness equipment in a green courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f2901981-ecea-4040-bb39-e2c9cb3d05c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-337f-72be-b518-01eb6e8a7b06.webp",
      "image_media": {
        "alt_text": "A clean, modern bedroom with a queen-size bed, nightstands, and large windows with decorative curtains.",
        "public_id": "019e8a04-337f-72be-b518-01eb6e8a7b06",
        "storage_key": "property/5675057267343360/019e8a04-337f-72be-b518-01eb6e8a7b06.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Step into comfort in this stylish bedroom, featuring a plush queen-size bed and ample natural light. Perfect for relaxation and rest.",
      "link": "",
      "alt_text": "A clean, modern bedroom with a queen-size bed, nightstands, and large windows with decorative curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af5e9d00-730e-4d81-9fa4-5ae7de5c73a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-3371-76de-94ca-e08502742d91.webp",
      "image_media": {
        "alt_text": "Living room and bedroom of an apartment.",
        "public_id": "019e8a04-3371-76de-94ca-e08502742d91",
        "storage_key": "property/5675057267343360/019e8a04-3371-76de-94ca-e08502742d91.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room adjacent to a cozy bedroom, perfect for modern living.",
      "link": "",
      "alt_text": "Living room and bedroom of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82680191-e335-470c-9396-1ee250c39305",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-2f7e-72c9-bd9a-a0944d2262b0.webp",
      "image_media": {
        "alt_text": "Spinning bikes and free weights in a well-equipped fitness center.",
        "public_id": "019e8a04-2f7e-72c9-bd9a-a0944d2262b0",
        "storage_key": "property/5675057267343360/019e8a04-2f7e-72c9-bd9a-a0944d2262b0.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, free weights, and space for yoga and stretching.",
      "link": "",
      "alt_text": "Spinning bikes and free weights in a well-equipped fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dff6dd1a-9e33-4b6b-8d14-2969ec983ea2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-34b3-734c-9214-005152b8db34.webp",
      "image_media": {
        "alt_text": "White stackable washer and dryer unit with top-loading washer and front-loading dryer.",
        "public_id": "019e8a04-34b3-734c-9214-005152b8db34",
        "storage_key": "property/5675057267343360/019e8a04-34b3-734c-9214-005152b8db34.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer make laundry day a breeze.",
      "link": "",
      "alt_text": "White stackable washer and dryer unit with top-loading washer and front-loading dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e90ea425-d0af-417b-9c37-27abedec23f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-2dd6-766a-af22-53b2edd82e2e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances.",
        "public_id": "019e8a04-2dd6-766a-af22-53b2edd82e2e",
        "storage_key": "property/5675057267343360/019e8a04-2dd6-766a-af22-53b2edd82e2e.webp",
        "width": 2362,
        "height": 1575
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring sleek cabinetry, a double sink, and a walk-in pantry, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0efe677b-5ba2-433a-a5f2-0fbe8b28e059",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019e8a04-2d0f-7078-bc74-0de86d616e7d.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and resort-style seating.",
        "public_id": "019e8a04-2d0f-7078-bc74-0de86d616e7d",
        "storage_key": "property/5675057267343360/019e8a04-2d0f-7078-bc74-0de86d616e7d.webp",
        "width": 1680,
        "height": 1120
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, complete with comfortable lounge chairs and serene surroundings. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and resort-style seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_cbbdfc40888a0d5d532e7123",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Eggs Up Grill",
      "poi_type": "Restaurants",
      "poi_address": "3679 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Relaxed chain serving a menu of breakfast, burgers & sandwiches in a colorful setting.",
      "poi_long_description": "Relaxed chain serving a menu of breakfast, burgers & sandwiches in a colorful setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-df14-7301-84af-85e3fd2fdbac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-df14-7301-84af-85e3fd2fdbac",
        "storage_key": "property/5675057267343360/019f14ef-df14-7301-84af-85e3fd2fdbac.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "https://locations.eggsupgrill.com/sc/ladson/39/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15256927900892483292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eggs-up-grill",
      "poi_latitude": "32.9799003",
      "poi_longitude": "-80.1287536",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-471-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt4hgTLiL_ogR3E5xWBd_u9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4617f603d3a8715e0cb60e8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3660 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-de8c-77fa-82aa-5410ad6d4c20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-de8c-77fa-82aa-5410ad6d4c20",
        "storage_key": "property/5675057267343360/019f14ef-de8c-77fa-82aa-5410ad6d4c20.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/sc/ladson-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17001960902454961270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.9823828",
      "poi_longitude": "-80.1266491",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-463-9945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwb_9HwCL_ogRdmToS1wZ8-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_de43221aaf3deb765dec97df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "3848 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-e3cf-713a-acbc-27254a0635b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-e3cf-713a-acbc-27254a0635b4",
        "storage_key": "property/5675057267343360/019f14ef-e3cf-713a-acbc-27254a0635b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.culvers.com/restaurants/ladson-sc-ladson/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=13939597042659378828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "32.9755698",
      "poi_longitude": "-80.1365988",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-285-9258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89vVH_-L_ogRjEbMt6dlc8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_cc0892c0cc90e6622085aa84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "3678 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-df21-7428-91d8-d72746437bf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-df21-7428-91d8-d72746437bf4",
        "storage_key": "property/5675057267343360/019f14ef-df21-7428-91d8-d72746437bf4.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/sc/ladson/3678-ladson-rd?y_source=1_MjA1NTM0MDAwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12137867514940486254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "32.9810183",
      "poi_longitude": "-80.1284795",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee2d-709a-ba0a-c8f87b7872c8",
        "storage_key": "property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJZd0sByKL_ogRbvLHFjJecqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_7e0b19ff3f6eed7c7496fea0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "3676 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-df27-740b-8eea-8b1c0b994fa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-df27-740b-8eea-8b1c0b994fa7",
        "storage_key": "property/5675057267343360/019f14ef-df27-740b-8eea-8b1c0b994fa7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/sc/ladson/3676-ladson-rd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=5535",
      "poi_directions_map_url": "https://maps.google.com/?cid=9084556857368383293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "32.9823719",
      "poi_longitude": "-80.1291293",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-376-6818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdPIYX-L_ogRPQ9IaVTUEn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_bedf945525c16347584c8b75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Krispy Kreme",
      "poi_type": "Restaurants",
      "poi_address": "3651 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_long_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-e3cf-713a-acbc-228822dfff1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-e3cf-713a-acbc-228822dfff1c",
        "storage_key": "property/5675057267343360/019f14ef-e3cf-713a-acbc-228822dfff1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://site.krispykreme.com/sc/ladson/3651-ladson-rd?y_source=1_MTU0NDcyODAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574820848940848066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krispy-kreme",
      "poi_latitude": "32.9821184",
      "poi_longitude": "-80.1242694",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-871-0401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJURl7ryqL_ogRwpPnbzwGoqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "ec_b8dbfeee16b32521b6d587e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "King's Pizza by: Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "3786 Ladson Rd Ste 201, Ladson, SC 29456, USA",
      "poi_short_description": "Understated pizzeria with basic decor turning out New York–style pies & familiar Italian classics.",
      "poi_long_description": "Understated pizzeria with basic decor turning out New York–style pies & familiar Italian classics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-df29-749b-85ba-97f7ae47e59c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-df29-749b-85ba-97f7ae47e59c",
        "storage_key": "property/5675057267343360/019f14ef-df29-749b-85ba-97f7ae47e59c.webp",
        "width": 289,
        "height": 312
      },
      "poi_business_url": "https://www.kingspizzaladson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11652810288104466996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-pizza-by-italian-bistro",
      "poi_latitude": "32.9779624",
      "poi_longitude": "-80.13270399999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-875-9630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYHjwDeK_ogRNOp7wTcZt6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_8247966d459bdc9527a98de3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Formosa Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "650 College Park Rd Unit D, Ladson, SC 29456, USA",
      "poi_short_description": "Familiar Chinese offerings & homestyle Filipino dishes in a petite, modest dining room.",
      "poi_long_description": "Familiar Chinese offerings & homestyle Filipino dishes in a petite, modest dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-df34-767c-904a-2617c2031fd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-df34-767c-904a-2617c2031fd5",
        "storage_key": "property/5675057267343360/019f14ef-df34-767c-904a-2617c2031fd5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/pages/Formosa/191254297619400",
      "poi_directions_map_url": "https://maps.google.com/?cid=7063399862320920269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "formosa-chinese-restaurant",
      "poi_latitude": "33.014067",
      "poi_longitude": "-80.08764029999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-569-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YoqlSJg_ogRzXYuVMA8BmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "ec_4815c0acaa08d84a980c7ced",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "HonkyTonk",
      "poi_type": "Restaurants",
      "poi_address": "192 College Park Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Casual, country-themed bar featuring live music, line-dancing lessons and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-e496-72bc-b002-f1b3a04f6076.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-e496-72bc-b002-f1b3a04f6076",
        "storage_key": "property/5675057267343360/019f14ef-e496-72bc-b002-f1b3a04f6076.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.honkytonksaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9926985945651579638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honkytonk",
      "poi_latitude": "32.9948175",
      "poi_longitude": "-80.0965497",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-569-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef4-72e0-99b8-b13fcb00a630",
        "storage_key": "property/5675057267343360/019f14ed-bef4-72e0-99b8-b13fcb00a630.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcQrYw9Vh_ogR9orbRB-9w4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_157ee3a28dfeb7d1234a0293",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Mellow & Play Cafe",
      "poi_type": "Restaurants",
      "poi_address": "9473 Hwy 78, Ladson, SC 29456, USA",
      "poi_short_description": "Casual play area, featuring inflatable structures and toys.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-e429-7568-9765-c16d93f8e00a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-e429-7568-9765-c16d93f8e00a",
        "storage_key": "property/5675057267343360/019f14ef-e429-7568-9765-c16d93f8e00a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mellowplaycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10292775750244822314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mellow--play-cafe",
      "poi_latitude": "32.9840104",
      "poi_longitude": "-80.092424",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-789-4743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee2d-709a-ba0a-c8f87b7872c8",
        "storage_key": "property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQTEn39th_ogRKu0Y6gJJ144",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_da7c0aa24e673a7089457900",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Hustleduck Coffee",
      "poi_type": "Restaurants",
      "poi_address": "9614 Hwy 78, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-edf1-738c-8645-8089a82b05e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-edf1-738c-8645-8089a82b05e5",
        "storage_key": "property/5675057267343360/019f14ef-edf1-738c-8645-8089a82b05e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hustleduck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11600760068865314716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hustleduck-coffee",
      "poi_latitude": "32.9892384",
      "poi_longitude": "-80.09900789999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-899-1765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee2d-709a-ba0a-c8f87b7872c8",
        "storage_key": "property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJoYm7kaeL_ogRnM9AtdEt_qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_bb2ac1431800a81894c26c86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "9585 Palmetto Commerce Pkwy, Ladson, SC 29456, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-eaec-7519-b9ec-55e446d02540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-eaec-7519-b9ec-55e446d02540",
        "storage_key": "property/5675057267343360/019f14ef-eaec-7519-b9ec-55e446d02540.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3411558319116848576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scooters-coffee",
      "poi_latitude": "32.9799543",
      "poi_longitude": "-80.1255242",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-285-5451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee2d-709a-ba0a-c8f87b7872c8",
        "storage_key": "property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJA3anBwCL_ogRwA19TTdKWC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_5eea63b82e5a2ee6f6fb32ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "La Pearla Tapatia Antojitos Mexicanos",
      "poi_type": "Restaurants",
      "poi_address": "637 Dutch Fork Dr, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2438168854399901543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-pearla-tapatia-antojitos-mexicanos",
      "poi_latitude": "32.9925648",
      "poi_longitude": "-80.10173189999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee2d-709a-ba0a-c8f87b7872c8",
        "storage_key": "property/5675057267343360/019f14f0-ee2d-709a-ba0a-c8f87b7872c8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ5dPfxYmL_ogRZ1_ttKcd1iE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_b07159fa5fbaea4b92df3914",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3685 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Pharmacy, bakery and grocery chain stocking everyday items electronics, toys, clothing and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-ea1a-772b-af28-7807a6a394c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-ea1a-772b-af28-7807a6a394c7",
        "storage_key": "property/5675057267343360/019f14ef-ea1a-772b-af28-7807a6a394c7.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.walmart.com/store/3713-ladson-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18099461261862547094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.9790044",
      "poi_longitude": "-80.12837999999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-879-5289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee5-73f8-a404-19e4192ef963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee5-73f8-a404-19e4192ef963",
        "storage_key": "property/5675057267343360/019f14ed-bee5-73f8-a404-19e4192ef963.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3fALdeL_ogRlq5CYx80Lvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_8d008516c7444a7ef969ce53",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "3786 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Chain grocery store offering produce, bulk food, and prepared items, plus organic products.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-ea22-7240-a6e7-bd91d46ae054.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-ea22-7240-a6e7-bd91d46ae054",
        "storage_key": "property/5675057267343360/019f14ef-ea22-7240-a6e7-bd91d46ae054.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.foodlion.com/sc/ladson/3786-ladson-rd.?y_source=1_NTA0Njg1OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9290431954940105084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "32.9785024",
      "poi_longitude": "-80.13385620000001",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-821-5908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee5-73f8-a404-19e4192ef963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee5-73f8-a404-19e4192ef963",
        "storage_key": "property/5675057267343360/019f14ed-bee5-73f8-a404-19e4192ef963.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDX8OdDiK_ogRfJEk5KM-7oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_0051c5a3b1118416571d981d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Piggly Wiggly",
      "poi_type": "Shopping & Retail",
      "poi_address": "9616 US-78, Ladson, SC 29456, USA",
      "poi_short_description": "Grocery store chain featuring meat and produce, plus prepared foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-f381-764e-88db-530bcc406f93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f381-764e-88db-530bcc406f93",
        "storage_key": "property/5675057267343360/019f14ef-f381-764e-88db-530bcc406f93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thepig.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7879144555761649797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piggly-wiggly",
      "poi_latitude": "32.9900016",
      "poi_longitude": "-80.09867500000001",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-572-2119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee5-73f8-a404-19e4192ef963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee5-73f8-a404-19e4192ef963",
        "storage_key": "property/5675057267343360/019f14ed-bee5-73f8-a404-19e4192ef963.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpS_69SqL_ogRhUggXDpYWG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_c417c2e667625a88da8eb1c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "1941 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-eda7-75fe-9594-bd2a7650f58e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-eda7-75fe-9594-bd2a7650f58e",
        "storage_key": "property/5675057267343360/019f14ef-eda7-75fe-9594-bd2a7650f58e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/summerville-sc-pharmacies/1941-n-main-st-summerville-sc-29483/storeid=5580?WT.mc_id=LS_GOOGLE_FS_5580",
      "poi_directions_map_url": "https://maps.google.com/?cid=2915986923071696670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.0435191",
      "poi_longitude": "-80.1203948",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-875-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aZbfrWK_ogRHm9fL6iqdyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_fc1545a0d8da562f0036b6fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "9880 Dorchester Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Department store offering a wide range of merchandise, including electronics, home furnishings, and clothing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-f8e5-76e4-a162-c3389af9990f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f8e5-76e4-a162-c3389af9990f",
        "storage_key": "property/5675057267343360/019f14ef-f8e5-76e4-a162-c3389af9990f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/628-summerville-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1830343504331983125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.950211",
      "poi_longitude": "-80.15524359999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-871-3303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8QC-hWWJ_ogRFcmmOLivZhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_3dd12bde6617df6bca015137",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3786 Ladson Rd Ste. 302, Ladson, SC 29456, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-f82d-732a-beb7-4eb7fadb586b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f82d-732a-beb7-4eb7fadb586b",
        "storage_key": "property/5675057267343360/019f14ef-f82d-732a-beb7-4eb7fadb586b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.familydollar.com/sc/ladson/3786-ladson-rd-ste-302?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13933739763572225951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "32.9786778",
      "poi_longitude": "-80.1335507",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 854-220-1251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmYHjwDeK_ogRnzd1qH2WXsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_3d122d2804d2a1d710572614",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "113 College Park Rd Ste A, Ladson, SC 29456, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-fcc7-746b-963a-7574bf0d2855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-fcc7-746b-963a-7574bf0d2855",
        "storage_key": "property/5675057267343360/019f14ef-fcc7-746b-963a-7574bf0d2855.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dollartree.com/sc/ladson/113-college-park-rd-suite-a?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7536074833759730581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "32.9909776",
      "poi_longitude": "-80.10187959999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 843-695-9575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbTPc_nSL_ogRlXsCKyKElWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_8fd9a06600eb9ad1ae368606",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Helpful Hardware Ace of Ladson",
      "poi_type": "Shopping & Retail",
      "poi_address": "548 College Park Rd, Ladson, SC 29456, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-0432-7694-ab0c-4976102ce5a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-0432-7694-ab0c-4976102ce5a4",
        "storage_key": "property/5675057267343360/019f14f0-0432-7694-ab0c-4976102ce5a4.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "http://www.helpfulhardwareco.com/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=18687",
      "poi_directions_map_url": "https://maps.google.com/?cid=6792268943094298652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "helpful-hardware-ace-of-ladson",
      "poi_latitude": "33.0083387",
      "poi_longitude": "-80.0878412",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-572-1223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-c2N3S9g_ogRHLgN5J38Ql4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "ec_8621f145eba40663c1786f96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "10216 Hwy 78, Ladson, SC 29456, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-f62e-7567-a192-7e3d27f19660.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f62e-7567-a192-7e3d27f19660",
        "storage_key": "property/5675057267343360/019f14ef-f62e-7567-a192-7e3d27f19660.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/sc/ladson/2848",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719280824374276687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "33.0101832",
      "poi_longitude": "-80.13059919999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 843-851-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_WMsAnmK_ogRTzIMduxjRcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_fe18a778f19c0d2c74e27af7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Sunoco",
      "poi_type": "Shopping & Retail",
      "poi_address": "336 College Park Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-f7bb-7570-82e7-e7c39c765183.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f7bb-7570-82e7-e7c39c765183",
        "storage_key": "property/5675057267343360/019f14ef-f7bb-7570-82e7-e7c39c765183.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.sunoco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=578491073084725021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco",
      "poi_latitude": "33.0000351",
      "poi_longitude": "-80.0915517",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-797-1891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee31-72ed-9143-b327f02fb970.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee31-72ed-9143-b327f02fb970",
        "storage_key": "property/5675057267343360/019f14f0-ee31-72ed-9143-b327f02fb970.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0YTuSxg_ogRHRfz5JA2Bwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_48526a856264cdbb4ad40668",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "College Park Elementary School",
      "poi_type": "Education",
      "poi_address": "100 Davidson Dr, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-004d-711f-b1ef-dcd67d8c50f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-004d-711f-b1ef-dcd67d8c50f5",
        "storage_key": "property/5675057267343360/019f14f0-004d-711f-b1ef-dcd67d8c50f5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.bcsdschools.net/o/cpe",
      "poi_directions_map_url": "https://maps.google.com/?cid=13468768201267102075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-park-elementary-school",
      "poi_latitude": "33.016191",
      "poi_longitude": "-80.0906727",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-797-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3_FnjyNg_ogRe0GahlGt6ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_6739b5554f6596e6dcd1bc60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Little Hands",
      "poi_type": "Education",
      "poi_address": "573 College Park Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-0580-75ce-aebe-184ac3256705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-0580-75ce-aebe-184ac3256705",
        "storage_key": "property/5675057267343360/019f14f0-0580-75ce-aebe-184ac3256705.webp",
        "width": 1280,
        "height": 1079
      },
      "poi_business_url": "http://lhchildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14280062046225055700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-hands",
      "poi_latitude": "33.0098922",
      "poi_longitude": "-80.0891757",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-996-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ___rhy9g_ogR1D_Io8X4LMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_fa764d65b65357b41211fc65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Palmetto Child Care",
      "poi_type": "Education",
      "poi_address": "3525 Iron Horse Rd #108, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-fc24-76e0-b97f-9ff097706846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-fc24-76e0-b97f-9ff097706846",
        "storage_key": "property/5675057267343360/019f14ef-fc24-76e0-b97f-9ff097706846.webp",
        "width": 448,
        "height": 358
      },
      "poi_business_url": "http://www.palmettochildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16943768814936826962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmetto-child-care",
      "poi_latitude": "32.9828731",
      "poi_longitude": "-80.1151749",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-875-5898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt1yA9WuK_ogRUqSmGvdbJOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_5d94ac89baa58ea2111ca77b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Little People Big World",
      "poi_type": "Education",
      "poi_address": "267 Treeland Dr, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-0d33-7018-a947-029db8b17518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-0d33-7018-a947-029db8b17518",
        "storage_key": "property/5675057267343360/019f14f0-0d33-7018-a947-029db8b17518.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lpbwacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1860246512184787867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-people-big-world",
      "poi_latitude": "33.0152306",
      "poi_longitude": "-80.1172676",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-557-8171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHccnOpKK_ogRmwNvyVjs0Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_c96fae2949880c1999e962dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Joseph Pye Elementary School",
      "poi_type": "Education",
      "poi_address": "9701 Patriot Blvd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-0886-74ad-b096-ecd74b45d2e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-0886-74ad-b096-ecd74b45d2e2",
        "storage_key": "property/5675057267343360/019f14f0-0886-74ad-b096-ecd74b45d2e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ddtwo.org/JPES",
      "poi_directions_map_url": "https://maps.google.com/?cid=14543087012099684363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joseph-pye-elementary-school",
      "poi_latitude": "32.957571",
      "poi_longitude": "-80.11729729999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-695-2979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl5OwNB6K_ogRC3jMvZVs08k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_65a74e26084081d24c19786c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Ladson Elementary School",
      "poi_type": "Education",
      "poi_address": "3321 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-03dc-7029-a7eb-1bcbdafc8882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-03dc-7029-a7eb-1bcbdafc8882",
        "storage_key": "property/5675057267343360/019f14f0-03dc-7029-a7eb-1bcbdafc8882.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccsdschools.com/ladson",
      "poi_directions_map_url": "https://maps.google.com/?cid=12457091139819451955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ladson-elementary-school",
      "poi_latitude": "32.9854233",
      "poi_longitude": "-80.10595380000001",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-764-2225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-cwHa3GK_ogRM7aaI2R64Kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_7832542fd23039185b1f6327",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Sangaree Middle School",
      "poi_type": "Education",
      "poi_address": "1050 Discovery Dr, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-035c-73a4-954a-0ffb81fcd764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-035c-73a4-954a-0ffb81fcd764",
        "storage_key": "property/5675057267343360/019f14f0-035c-73a4-954a-0ffb81fcd764.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.bcsdschools.net/o/srm",
      "poi_directions_map_url": "https://maps.google.com/?cid=17467352993150551316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sangaree-middle-school",
      "poi_latitude": "33.0272231",
      "poi_longitude": "-80.1078131",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-821-4028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLdPWbKOK_ogRFEUYUwCBaPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_1b6fbe9d38542d9f881dd25c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Fort Dorchester High School",
      "poi_type": "Education",
      "poi_address": "8500 Patriot Blvd, North Charleston, SC 29420, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-0cd0-76ce-9095-81ecbd21c6ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-0cd0-76ce-9095-81ecbd21c6ea",
        "storage_key": "property/5675057267343360/019f14f0-0cd0-76ce-9095-81ecbd21c6ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ddtwo.org/FDHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=12559451981473167027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-dorchester-high-school",
      "poi_latitude": "32.9263391",
      "poi_longitude": "-80.1113045",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 843-760-4450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTwPgV8CJ_ogRs7ZIyQgjTK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_f38eae0d242b76e204cda7e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Trident Technical College",
      "poi_type": "Education",
      "poi_address": "7000 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-07d4-7725-a7e4-c1a100252067.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-07d4-7725-a7e4-c1a100252067",
        "storage_key": "property/5675057267343360/019f14f0-07d4-7725-a7e4-c1a100252067.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.tridenttech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12635303724822809317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trident-technical-college",
      "poi_latitude": "32.9280591",
      "poi_longitude": "-80.0307641",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-574-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaftirupj_ogR5co7A8udWa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_957a918088603229d23c888f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Charleston Southern University",
      "poi_type": "Education",
      "poi_address": "9200 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-77db-7309-8e2b-b3e45b74baff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-77db-7309-8e2b-b3e45b74baff",
        "storage_key": "property/5675057267343360/019f14ed-77db-7309-8e2b-b3e45b74baff.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.charlestonsouthern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18389572263007151393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleston-southern-university",
      "poi_latitude": "32.9821829",
      "poi_longitude": "-80.07065539999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-863-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCTNMZLlh_ogRIeXqg4riNP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_69bf3f340fe801f46d0127a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Cinemark Summerville",
      "poi_type": "Entertainment",
      "poi_address": "4488 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-13f1-74e1-b782-dd175d287e1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-13f1-74e1-b782-dd175d287e1b",
        "storage_key": "property/5675057267343360/019f14f0-13f1-74e1-b782-dd175d287e1b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cinemark.com/theatres/sc-summerville/cinemark-summerville?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MjMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669461560650978369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-summerville",
      "poi_latitude": "32.9586398",
      "poi_longitude": "-80.16016859999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-873-1501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee2e-7120-88d2-4ea6f52f0e61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee2e-7120-88d2-4ea6f52f0e61",
        "storage_key": "property/5675057267343360/019f14f0-ee2e-7120-88d2-4ea6f52f0e61.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QEgZ9eL_ogRQVRJm8KKEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_55f36d07dc227ea3927e2d81",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Regal Palmetto Grande",
      "poi_type": "Entertainment",
      "poi_address": "1319 Theater Dr, Mt Pleasant, SC 29464, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-131b-70a0-8073-007449e3169d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-131b-70a0-8073-007449e3169d",
        "storage_key": "property/5675057267343360/019f14f0-131b-70a0-8073-007449e3169d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-palmetto-grande-1884?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=470395181026045199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-palmetto-grande",
      "poi_latitude": "32.82999",
      "poi_longitude": "-79.82799",
      "poi_miles_from_property": "42.4 mi",
      "poi_walking_minutes": "15 hours 25 mins",
      "poi_biking_minutes": "2 hours 42 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee2e-7120-88d2-4ea6f52f0e61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee2e-7120-88d2-4ea6f52f0e61",
        "storage_key": "property/5675057267343360/019f14f0-ee2e-7120-88d2-4ea6f52f0e61.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-e3NdR1y_ogRD-0cxewthwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_6ad4c250172e8951d566548c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "South Carolina Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "100 Aquarium Wharf, Charleston, SC 29401, USA",
      "poi_short_description": "Massive aquarium with interactive exhibits & hundreds of creatures, including many native species.",
      "poi_long_description": "Massive aquarium with interactive exhibits & hundreds of creatures, including many native species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-19bc-749c-be02-eea13af18aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-19bc-749c-be02-eea13af18aef",
        "storage_key": "property/5675057267343360/019f14f0-19bc-749c-be02-eea13af18aef.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://scaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2084058560928962106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-aquarium",
      "poi_latitude": "32.7909936",
      "poi_longitude": "-79.92549919999999",
      "poi_miles_from_property": "34.9 mi",
      "poi_walking_minutes": "12 hours 40 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 843-577-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJof9jW3F6_ogROlZIJzgQ7Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_bd876b019cd84f9509df1d20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Childrens Museum of the Lowcountry",
      "poi_type": "Entertainment",
      "poi_address": "25 Ann St, Charleston, SC 29403, USA",
      "poi_short_description": "Hands-on exhibits for under-10 kids plus parties, programs, camps & classes such as yoga & dance.",
      "poi_long_description": "Hands-on exhibits for under-10 kids plus parties, programs, camps & classes such as yoga & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-1af6-77b8-a410-a0692512d4d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-1af6-77b8-a410-a0692512d4d6",
        "storage_key": "property/5675057267343360/019f14f0-1af6-77b8-a410-a0692512d4d6.webp",
        "width": 1275,
        "height": 753
      },
      "poi_business_url": "http://www.explorecml.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3212388673014336480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-the-lowcountry",
      "poi_latitude": "32.789416",
      "poi_longitude": "-79.9376529",
      "poi_miles_from_property": "34.0 mi",
      "poi_walking_minutes": "12 hours 21 mins",
      "poi_biking_minutes": "2 hours 1 min",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee35-73db-9f60-f812c0511292",
        "storage_key": "property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4cWvWt6_ogR4AuCZ3qylCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_678caf0257c3ef8b8f3bc291",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Music Farm",
      "poi_type": "Entertainment",
      "poi_address": "32 Ann St, Charleston, SC 29403, USA",
      "poi_short_description": "Bands & a full bar featured in a standing-only concert & event hall housed in a former train shed.",
      "poi_long_description": "Bands & a full bar featured in a standing-only concert & event hall housed in a former train shed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-1823-730b-bea2-3774ddc7f2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-1823-730b-bea2-3774ddc7f2d6",
        "storage_key": "property/5675057267343360/019f14f0-1823-730b-bea2-3774ddc7f2d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://musicfarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18432997355552395870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "music-farm",
      "poi_latitude": "32.78998869999999",
      "poi_longitude": "-79.93815049999999",
      "poi_miles_from_property": "34.1 mi",
      "poi_walking_minutes": "12 hours 22 mins",
      "poi_biking_minutes": "2 hours 0 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 843-853-2252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ26Ant2t6_ogRXlJqw24pz_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_793e89fb932b1159ca6bf030",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Charleston Music Hall",
      "poi_type": "Entertainment",
      "poi_address": "37 John St, Charleston, SC 29403, USA",
      "poi_short_description": "19th-century Gothic Revival building, now a venue for concerts, dance, theater & comedy shows.",
      "poi_long_description": "19th-century Gothic Revival building, now a venue for concerts, dance, theater & comedy shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-289c-72c2-aaa5-3ae324d139ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-289c-72c2-aaa5-3ae324d139ef",
        "storage_key": "property/5675057267343360/019f14f0-289c-72c2-aaa5-3ae324d139ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlestonmusichall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16799454568286003850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleston-music-hall",
      "poi_latitude": "32.7884395",
      "poi_longitude": "-79.9369071",
      "poi_miles_from_property": "34.1 mi",
      "poi_walking_minutes": "12 hours 22 mins",
      "poi_biking_minutes": "2 hours 1 min",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 843-853-2252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0f93d2t6_ogRiiIAK-ymI-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_aefab2ade8c4f551d6db5d87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "North Charleston Coliseum & Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "5001 Coliseum Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "Indoor stadium & adjacent theater where thousands watch minor league hockey, concerts & plays.",
      "poi_long_description": "Indoor stadium & adjacent theater where thousands watch minor league hockey, concerts & plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-2e7e-75be-813e-fb96fae8854a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-2e7e-75be-813e-fb96fae8854a",
        "storage_key": "property/5675057267343360/019f14f0-2e7e-75be-813e-fb96fae8854a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northcharlestoncoliseumpac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4984177135569200452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-coliseum--performing-arts-center",
      "poi_latitude": "32.8654952",
      "poi_longitude": "-80.02243399999999",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-529-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6YMfE5j_ogRROU5j7JaK0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_4cc56e5da346af26db2a988e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Patriots Point Naval & Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "40 Patriots Point Rd, Mt Pleasant, SC 29464, USA",
      "poi_short_description": "Visitors can explore a retired Naval aircraft carrier, destroyer & submarine docked here year-round.",
      "poi_long_description": "Visitors can explore a retired Naval aircraft carrier, destroyer & submarine docked here year-round.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-1c20-71fb-b457-d2e088e7dce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-1c20-71fb-b457-d2e088e7dce6",
        "storage_key": "property/5675057267343360/019f14f0-1c20-71fb-b457-d2e088e7dce6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.patriotspoint.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2736798978077254358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patriots-point-naval--maritime-museum",
      "poi_latitude": "32.7905312",
      "poi_longitude": "-79.9056076",
      "poi_miles_from_property": "38.1 mi",
      "poi_walking_minutes": "13 hours 50 mins",
      "poi_biking_minutes": "2 hours 16 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 843-884-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee35-73db-9f60-f812c0511292",
        "storage_key": "property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZ61VpBw_ogR1mLynSsQ-yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_2bfcecd3b01be5cab8236c91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "The Charleston Museum",
      "poi_type": "Entertainment",
      "poi_address": "360 Meeting St, Charleston, SC 29403, USA",
      "poi_short_description": "America's first museum, founded in 1773, exhibits relics from South Carolina & Confederate history.",
      "poi_long_description": "America's first museum, founded in 1773, exhibits relics from South Carolina & Confederate history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-24bb-71d7-9051-cb2b9d5143af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-24bb-71d7-9051-cb2b9d5143af",
        "storage_key": "property/5675057267343360/019f14f0-24bb-71d7-9051-cb2b9d5143af.webp",
        "width": 1280,
        "height": 943
      },
      "poi_business_url": "https://www.charlestonmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10721274389353507098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-charleston-museum",
      "poi_latitude": "32.7896061",
      "poi_longitude": "-79.9356663",
      "poi_miles_from_property": "34.2 mi",
      "poi_walking_minutes": "12 hours 24 mins",
      "poi_biking_minutes": "2 hours 0 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 843-722-2996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee35-73db-9f60-f812c0511292",
        "storage_key": "property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3e6RdWx6_ogRGqno3ECeyZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_0ab5f5c4bce34fecc8b097d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Gibbes Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "135 Meeting St, Charleston, SC 29401, USA",
      "poi_short_description": "Portraits & landscapes dating back to the 1700s, housed in a century-old beaux arts-style building.",
      "poi_long_description": "Portraits & landscapes dating back to the 1700s, housed in a century-old beaux arts-style building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-2ed0-773a-a71f-84d8360c8c9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-2ed0-773a-a71f-84d8360c8c9c",
        "storage_key": "property/5675057267343360/019f14f0-2ed0-773a-a71f-84d8360c8c9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gibbesmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436130629935220899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gibbes-museum-of-art",
      "poi_latitude": "32.7785342",
      "poi_longitude": "-79.931906",
      "poi_miles_from_property": "34.9 mi",
      "poi_walking_minutes": "12 hours 40 mins",
      "poi_biking_minutes": "2 hours 6 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 843-722-2706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee35-73db-9f60-f812c0511292",
        "storage_key": "property/5675057267343360/019f14f0-ee35-73db-9f60-f812c0511292.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXwr6xF6_ogRo8ggP5qWry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_059483d2a570934dc29d2e89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "HCA Healthcare Trident Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9330 Medical Plaza Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-9b8e-72b4-9d4f-d6f77a9e63bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-9b8e-72b4-9d4f-d6f77a9e63bc",
        "storage_key": "property/5675057267343360/019f14ed-9b8e-72b4-9d4f-d6f77a9e63bc.webp",
        "width": 1010,
        "height": 568
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/trident-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177182806905145430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare-trident-hospital",
      "poi_latitude": "32.9762771",
      "poi_longitude": "-80.07362309999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-797-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef1-7201-a3af-93f7f037a684",
        "storage_key": "property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTtamr9h_ogRVkjrvnRTQvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a53d4319085998904a52f39e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Roper St. Francis Express Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4278 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-38a3-7013-bb9e-d6bd4f8acede.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-38a3-7013-bb9e-d6bd4f8acede",
        "storage_key": "property/5675057267343360/019f14f0-38a3-7013-bb9e-d6bd4f8acede.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rsfh.com/express-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10224232497040185996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roper-st-francis-express-care",
      "poi_latitude": "32.963744",
      "poi_longitude": "-80.1538918",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-203-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzfEUX9eL_ogRjNoVJ0nF440",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f5fa2a438d6dd1e38213098e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1941 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ef-eda7-75fe-9594-bd2a7650f58e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-eda7-75fe-9594-bd2a7650f58e",
        "storage_key": "property/5675057267343360/019f14ef-eda7-75fe-9594-bd2a7650f58e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/summerville-sc-pharmacies/1941-n-main-st-summerville-sc-29483/storeid=5580?WT.mc_id=LS_GOOGLE_FS_5580",
      "poi_directions_map_url": "https://maps.google.com/?cid=2915986923071696670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.0435191",
      "poi_longitude": "-80.1203948",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-875-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aZbfrWK_ogRHm9fL6iqdyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_a269da03f206764d0cac066c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3685 Ladson Rd, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-2903-775d-9fa6-ecf0e90f800f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-2903-775d-9fa6-ecf0e90f800f",
        "storage_key": "property/5675057267343360/019f14f0-2903-775d-9fa6-ecf0e90f800f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/3713-ladson-sc/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=542498954854264932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "32.9787908",
      "poi_longitude": "-80.1285374",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-879-5288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee40-72db-9fbc-76231f872d92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee40-72db-9fbc-76231f872d92",
        "storage_key": "property/5675057267343360/019f14f0-ee40-72db-9fbc-76231f872d92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3fALdeL_ogRZPAb1-xXhwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d7a2b21fd774262ea543cc61",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Piggly Wiggly Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9616 Hwy 78 Ste 6, Ladson, SC 29456, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-37e1-749f-bdf0-ca5b4e5f4b89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-37e1-749f-bdf0-ca5b4e5f4b89",
        "storage_key": "property/5675057267343360/019f14f0-37e1-749f-bdf0-ca5b4e5f4b89.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "http://www.pigglywigglyrx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9646693170219150093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piggly-wiggly-pharmacy",
      "poi_latitude": "32.9899709",
      "poi_longitude": "-80.09889179999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-800-8788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee40-72db-9fbc-76231f872d92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee40-72db-9fbc-76231f872d92",
        "storage_key": "property/5675057267343360/019f14f0-ee40-72db-9fbc-76231f872d92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIy4UtnmK_ogRDWsZ9FPw34U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0f12a814cd8dd3c021c12f63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "CrossFit Sacred Pine",
      "poi_type": "Health and Wellness",
      "poi_address": "3507 Iron Horse Rd Unit 300, Ladson, SC 29456, USA",
      "poi_short_description": "Cozy gym offering CrossFit workouts and classes, plus coaches who modify movements as needed.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-34a9-7726-9f3b-9bab9ebf6e86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-34a9-7726-9f3b-9bab9ebf6e86",
        "storage_key": "property/5675057267343360/019f14f0-34a9-7726-9f3b-9bab9ebf6e86.webp",
        "width": 960,
        "height": 541
      },
      "poi_business_url": "https://sacredpinefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16826905831592729490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-sacred-pine",
      "poi_latitude": "32.9831107",
      "poi_longitude": "-80.1133413",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-919-4869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZz1MWyK_ogRkpsIebMthek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_055d5031495c27d3239535b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1341 College Park Rd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-89d4-760e-a2ee-54611c51bb70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-89d4-760e-a2ee-54611c51bb70",
        "storage_key": "property/5675057267343360/019f14ed-89d4-760e-a2ee-54611c51bb70.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/summerville-college-park-sc?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7878199314101852113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.0447652",
      "poi_longitude": "-80.107168",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 854-231-8030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2UnZ4SL_ogR0VfEIon8VG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_fa6ebc4d3efa47a10b6cd3ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Summerville Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "208 W Doty Ave, Summerville, SC 29483, USA",
      "poi_short_description": "Friendly staff run this gym with classes and programs for adults and kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-8dc8-7773-b0f9-284a8c7fd066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-8dc8-7773-b0f9-284a8c7fd066",
        "storage_key": "property/5675057267343360/019f14ed-8dc8-7773-b0f9-284a8c7fd066.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.summervilleymca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10561535591070080082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summerville-family-ymca",
      "poi_latitude": "33.0209912",
      "poi_longitude": "-80.1774669",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-871-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44OKmmWL_ogRUpxgpKkckpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a83a4fd5c070bd88c1c4180d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "9512 Dorchester Rd Ste. 150, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-38ab-720e-9a87-9f497ab25a10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-38ab-720e-9a87-9f497ab25a10",
        "storage_key": "property/5675057267343360/019f14f0-38ab-720e-9a87-9f497ab25a10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/summerville/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=810247052227064472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "32.9372552",
      "poi_longitude": "-80.141808",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-800-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE28oknGJ_ogRmDJNsGaTPgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_865eb0daeabf41e0597373e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Results Physiotherapy Summerville, South Carolina - Wescott",
      "poi_type": "Health and Wellness",
      "poi_address": "9512 Dorchester Rd Ste 140, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-42c9-70cb-8780-39bd11a14804.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-42c9-70cb-8780-39bd11a14804",
        "storage_key": "property/5675057267343360/019f14f0-42c9-70cb-8780-39bd11a14804.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "https://www.resultspt.com/summerville-wescott-sc?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1379152175634668764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "results-physiotherapy-summerville-south-carolina---wescott",
      "poi_latitude": "32.9371924",
      "poi_longitude": "-80.1418921",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-695-7970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCW8oknGJ_ogR3Fzpv5i7IxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_c98c68ab8bf005a9788d7f90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "North Charleston Wannamaker County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8888 University Blvd, North Charleston, SC 29406, USA",
      "poi_short_description": "Sprawling expanse of woodlands & wetlands with grills & picnic spots, plus a fee-based water park.",
      "poi_long_description": "Sprawling expanse of woodlands & wetlands with grills & picnic spots, plus a fee-based water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-a4d3-711e-95b3-6679dd9d45c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-a4d3-711e-95b3-6679dd9d45c9",
        "storage_key": "property/5675057267343360/019f14ed-a4d3-711e-95b3-6679dd9d45c9.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "http://ccprc.com/1737/North-Charleston-Wannamaker-County-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=557002064498803929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-wannamaker-county-park",
      "poi_latitude": "32.9771948",
      "poi_longitude": "-80.0541909",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-762-5585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf58-70cd-856b-6a5581cd76d8",
        "storage_key": "property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6pT-qBh_ogR2UScMW3eugc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1510943d7730a9a61d703e79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Colonial Dorchester State Historic Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 State Park Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_long_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-6521-7628-af2d-ee1f1de19a9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-6521-7628-af2d-ee1f1de19a9c",
        "storage_key": "property/5675057267343360/019f14f0-6521-7628-af2d-ee1f1de19a9c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.southcarolinaparks.com/colonialdorchester",
      "poi_directions_map_url": "https://maps.google.com/?cid=13989591396413956151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-dorchester-state-historic-site",
      "poi_latitude": "32.9487557",
      "poi_longitude": "-80.1705363",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-873-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf58-70cd-856b-6a5581cd76d8",
        "storage_key": "property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRy4OfGL_ogRN2AdSEEDJcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_bb542a3030f1f253407d9184",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Rosebrock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "507 Beech Hill Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Natural setting for riverside hikes through forest & wetlands, plus a picnic shelter.",
      "poi_long_description": "Natural setting for riverside hikes through forest & wetlands, plus a picnic shelter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-4d59-74a9-a27b-d5b73f3947f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4d59-74a9-a27b-d5b73f3947f8",
        "storage_key": "property/5675057267343360/019f14f0-4d59-74a9-a27b-d5b73f3947f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/rosebrock-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16520332637351917944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosebrock-park",
      "poi_latitude": "32.9489457",
      "poi_longitude": "-80.2059668",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-832-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf58-70cd-856b-6a5581cd76d8",
        "storage_key": "property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5ApnaeO_ogReDmnVAEDROU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5c00de7ca246698163b8f51c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Ashley River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 Renken Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Relaxed riverside park featuring playgrounds, walking trails, dog parks and zip lines.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-b721-70ed-a572-f1ceb80c7c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-b721-70ed-a572-f1ceb80c7c47",
        "storage_key": "property/5675057267343360/019f14ed-b721-70ed-a572-f1ceb80c7c47.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/parks-master-plan/ashley-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8523128911980528156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ashley-river-park",
      "poi_latitude": "32.9596824",
      "poi_longitude": "-80.2003158",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-806-2426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf58-70cd-856b-6a5581cd76d8",
        "storage_key": "property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97nbMiaP_ogRHAJ2hZY8SHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_da8458fc06959be43c49bb33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Azalea Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 W 5th S St, Summerville, SC 29483, USA",
      "poi_short_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_long_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-696c-760c-b7bc-59a0ffa16b73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-696c-760c-b7bc-59a0ffa16b73",
        "storage_key": "property/5675057267343360/019f14f0-696c-760c-b7bc-59a0ffa16b73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/196/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16921181544976970789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "azalea-park",
      "poi_latitude": "33.0143515",
      "poi_longitude": "-80.1774669",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-851-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf58-70cd-856b-6a5581cd76d8",
        "storage_key": "property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fBkAnuL_ogRJXQ_gPYc1Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fbb0e938aecc9184a4826bec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1061 Everglades Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "This popular green space along the Cooper River features a large meadow & performance pavilion.",
      "poi_long_description": "This popular green space along the Cooper River features a large meadow & performance pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-5658-7508-af8f-7acd26c0adae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5658-7508-af8f-7acd26c0adae",
        "storage_key": "property/5675057267343360/019f14f0-5658-7508-af8f-7acd26c0adae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.northcharleston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8626706816767301319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverfront-park",
      "poi_latitude": "32.8675754",
      "poi_longitude": "-79.966717",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 27 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 843-308-4746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf58-70cd-856b-6a5581cd76d8",
        "storage_key": "property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZpkTthk_ogRxxbbwiQ4uHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e07fc50f250ef440dc8d15be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Crowfield Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Hamlet Cir, Goose Creek, SC 29445, USA",
      "poi_short_description": "Fairly priced and well-maintained private golf course with challenging holes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-5a40-753d-bbcd-90cb93463b0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5a40-753d-bbcd-90cb93463b0a",
        "storage_key": "property/5675057267343360/019f14f0-5a40-753d-bbcd-90cb93463b0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crowfieldgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=310638221480453266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crowfield-golf-club",
      "poi_latitude": "33.0036353",
      "poi_longitude": "-80.07741829999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-764-4618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZde2EDRg_ogRkmQADdGbTwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "ec_e357b2ecc9c91c39baf67116",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Herbert H. Jessen Public Boat Landing",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4820 Ladson Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-65eb-715f-9faa-e45903255698.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-65eb-715f-9faa-e45903255698",
        "storage_key": "property/5675057267343360/019f14f0-65eb-715f-9faa-e45903255698.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/Facilities/Facility/Details/Herbert-H-Jessen-Boat-Landing-10",
      "poi_directions_map_url": "https://maps.google.com/?cid=6858014639842278247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herbert-h-jessen-public-boat-landing",
      "poi_latitude": "32.947468",
      "poi_longitude": "-80.164812",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3r7I2iJ_ogRZzs6yPqPLF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_d58c73e6b6562390dee648be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Pine Trace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "303 Chandler Creek Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-64c9-7656-80f9-fd629ae4e6a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-64c9-7656-80f9-fd629ae4e6a8",
        "storage_key": "property/5675057267343360/019f14f0-64c9-7656-80f9-fd629ae4e6a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/pine-trace-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2357599917483286512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pine-trace-park",
      "poi_latitude": "32.9821335",
      "poi_longitude": "-80.1572965",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-563-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf58-70cd-856b-6a5581cd76d8",
        "storage_key": "property/5675057267343360/019f14ed-bf58-70cd-856b-6a5581cd76d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZyHWceL_ogR8N8URKLgtyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_44f234442ac54247527319cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Rivers Ave Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ridecarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17678888608492561643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivers-ave-park--ride",
      "poi_latitude": "32.9612499",
      "poi_longitude": "-80.04670089999999",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdy0NvXBh_ogR6yTmzIUHWPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_a46e62d33790796074fbcf7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "North Charleston Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4565 Gaynor Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-5d5b-76c3-8d1a-c1e0c3dce4db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5d5b-76c3-8d1a-c1e0c3dce4db",
        "storage_key": "property/5675057267343360/019f14f0-5d5b-76c3-8d1a-c1e0c3dce4db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridecarta.com/news-announcements/intermodal-facility-project/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18388241308575805294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-transit-center",
      "poi_latitude": "32.8755257",
      "poi_longitude": "-79.9979853",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-Lvgxdl_ogRbi_TiQsoMP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_8c36bfc426ab2aca063f3f0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Charleston International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5500 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_long_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-5f4f-70df-bd37-27b36cf0ffd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5f4f-70df-bd37-27b36cf0ffd2",
        "storage_key": "property/5675057267343360/019f14f0-5f4f-70df-bd37-27b36cf0ffd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.iflychs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2038942955165646559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleston-international-airport",
      "poi_latitude": "32.8916648",
      "poi_longitude": "-80.0395233",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 843-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee4d-7579-80f5-e700b000c84d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee4d-7579-80f5-e700b000c84d",
        "storage_key": "property/5675057267343360/019f14f0-ee4d-7579-80f5-e700b000c84d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyrqSw9j_ogR3_7un9DHSxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_8bc7baf85407633f8f14eafe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "CARTA",
      "poi_type": "Transportation & Transit",
      "poi_address": "3664 Leeds Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ad0d-7143-a06f-aeeae72e4baa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-ad0d-7143-a06f-aeeae72e4baa",
        "storage_key": "property/5675057267343360/019f14f0-ad0d-7143-a06f-aeeae72e4baa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ridecarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7177070893230486091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carta",
      "poi_latitude": "32.8528056",
      "poi_longitude": "-80.0124297",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 44 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-745-4101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfy-WY6l8_ogRS3LMnvMTmmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_3514578c9c17cced728df24c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Oakbrook Station Shopping Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "10020 Dorchester Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Clean, modern supermarket carrying produce, local items, wine, cheese and baked goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-8392-7259-87b6-275748ef4fbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-8392-7259-87b6-275748ef4fbb",
        "storage_key": "property/5675057267343360/019f14f0-8392-7259-87b6-275748ef4fbb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17613698407844240057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakbrook-station-shopping-center",
      "poi_latitude": "32.9538841",
      "poi_longitude": "-80.1644668",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 310-995-9992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYymsN2eJ_ogRuVprbGFtcPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_5eaa3ec37ceb27d3e433f9f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "North Charleston Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Melnick Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-7e87-77da-9bcc-6e7eca0645fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-7e87-77da-9bcc-6e7eca0645fb",
        "storage_key": "property/5675057267343360/019f14f0-7e87-77da-9bcc-6e7eca0645fb.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://ridecarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7348761912706324910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-park--ride",
      "poi_latitude": "32.9610865",
      "poi_longitude": "-80.0470412",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee9a-73d4-9809-b98d35c070c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee9a-73d4-9809-b98d35c070c3",
        "storage_key": "property/5675057267343360/019f14f0-ee9a-73d4-9809-b98d35c070c3.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbJnFGRh_ogRrtnHMQYM_GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_6851e12187beb7d0e6554c5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Tanger Outlets Charleston",
      "poi_type": "Transportation & Transit",
      "poi_address": "4840 Tanger Outlet Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-8b79-72c0-935b-b7ae34a0e74e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-8b79-72c0-935b-b7ae34a0e74e",
        "storage_key": "property/5675057267343360/019f14f0-8b79-72c0-935b-b7ae34a0e74e.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.tangeroutlet.com/charleston",
      "poi_directions_map_url": "https://maps.google.com/?cid=10411492147648175344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanger-outlets-charleston",
      "poi_latitude": "32.8737687",
      "poi_longitude": "-80.01930109999999",
      "poi_miles_from_property": "16.0 mi",
      "poi_walking_minutes": "5 hours 51 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-529-3095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE9b7HVtj_ogR8JxWIvIMfZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_960b172c6e171ea1071475ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Boeing South Carolina Delivery Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 Airframe Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-8781-746c-8491-5811ba49a815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-8781-746c-8491-5811ba49a815",
        "storage_key": "property/5675057267343360/019f14f0-8781-746c-8491-5811ba49a815.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1818565927026470829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boeing-south-carolina-delivery-center",
      "poi_latitude": "32.8772636",
      "poi_longitude": "-80.027445",
      "poi_miles_from_property": "13.8 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 312-544-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtVx4OUFj_ogRra8KURPYPBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_b786cbef2070d5a1cfd3c000",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Charleston International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5500 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_long_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-5f4f-70df-bd37-27b36cf0ffd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5f4f-70df-bd37-27b36cf0ffd2",
        "storage_key": "property/5675057267343360/019f14f0-5f4f-70df-bd37-27b36cf0ffd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.iflychs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2038942955165646559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleston-international-airport",
      "poi_latitude": "32.8916648",
      "poi_longitude": "-80.0395233",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 843-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-ee4d-7579-80f5-e700b000c84d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-ee4d-7579-80f5-e700b000c84d",
        "storage_key": "property/5675057267343360/019f14f0-ee4d-7579-80f5-e700b000c84d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyrqSw9j_ogR3_7un9DHSxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_14cbdc5f33e779b439df9f97",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Naval Weapons Station, Joint Base Charleston",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2300 Red Bank Rd, Goose Creek, SC 29445, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-8be3-73e3-8504-32dd45fa7de2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-8be3-73e3-8504-32dd45fa7de2",
        "storage_key": "property/5675057267343360/019f14f0-8be3-73e3-8504-32dd45fa7de2.webp",
        "width": 684,
        "height": 528
      },
      "poi_business_url": "https://www.jbcharleston.jb.mil/About-Us/Facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9546829583179097960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naval-weapons-station-joint-base-charleston",
      "poi_latitude": "32.9585403",
      "poi_longitude": "-79.9370344",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 843-963-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf10-779b-97e5-7b6bf7c9a0d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf10-779b-97e5-7b6bf7c9a0d8",
        "storage_key": "property/5675057267343360/019f14ed-bf10-779b-97e5-7b6bf7c9a0d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqp5i_ogRaKeUtOwmfYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_87b18253c4cc91c815fd412f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Amazon Warehouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7290 Investment Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-9c26-71f8-8539-d0d5c8916dfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-9c26-71f8-8539-d0d5c8916dfa",
        "storage_key": "property/5675057267343360/019f14f0-9c26-71f8-8539-d0d5c8916dfa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2263429633063308387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-warehouse",
      "poi_latitude": "32.924797",
      "poi_longitude": "-80.0596754",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf01-7439-9992-b5a9f9bb29ee",
        "storage_key": "property/5675057267343360/019f14ed-bf01-7439-9992-b5a9f9bb29ee.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcX_mWkli_ogRY8zUVEJRaR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_917ca80172ca2320591089b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "HCA Healthcare Trident Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9330 Medical Plaza Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-9b8e-72b4-9d4f-d6f77a9e63bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-9b8e-72b4-9d4f-d6f77a9e63bc",
        "storage_key": "property/5675057267343360/019f14ed-9b8e-72b4-9d4f-d6f77a9e63bc.webp",
        "width": 1010,
        "height": 568
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/trident-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177182806905145430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare-trident-hospital",
      "poi_latitude": "32.9762771",
      "poi_longitude": "-80.07362309999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-797-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef1-7201-a3af-93f7f037a684",
        "storage_key": "property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTtamr9h_ogRVkjrvnRTQvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_70025962519f33477b82f2de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Trident Technical College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7000 Rivers Ave, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-07d4-7725-a7e4-c1a100252067.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-07d4-7725-a7e4-c1a100252067",
        "storage_key": "property/5675057267343360/019f14f0-07d4-7725-a7e4-c1a100252067.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.tridenttech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12635303724822809317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trident-technical-college",
      "poi_latitude": "32.9280591",
      "poi_longitude": "-80.0307641",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-574-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef5-73e0-94a0-0d62ae8453f8",
        "storage_key": "property/5675057267343360/019f14ed-bef5-73e0-94a0-0d62ae8453f8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaftirupj_ogR5co7A8udWa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_abbeb6aba1f6d8b67ae24d4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "City of North Charleston City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2500 City Hall Ln, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-9ab0-7724-bbb4-7f0cee779d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-9ab0-7724-bbb4-7f0cee779d7c",
        "storage_key": "property/5675057267343360/019f14f0-9ab0-7724-bbb4-7f0cee779d7c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.northcharleston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2612516476197082924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-north-charleston-city-hall",
      "poi_latitude": "32.8766647",
      "poi_longitude": "-80.0118899",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-554-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bf10-779b-97e5-7b6bf7c9a0d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bf10-779b-97e5-7b6bf7c9a0d8",
        "storage_key": "property/5675057267343360/019f14ed-bf10-779b-97e5-7b6bf7c9a0d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1J_3V5j_ogRLBeVteSFQSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_28eaf9d78b1d8d31e2ee276f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "North Charleston Coliseum & Performing Arts Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5001 Coliseum Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "Indoor stadium & adjacent theater where thousands watch minor league hockey, concerts & plays.",
      "poi_long_description": "Indoor stadium & adjacent theater where thousands watch minor league hockey, concerts & plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-2e7e-75be-813e-fb96fae8854a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-2e7e-75be-813e-fb96fae8854a",
        "storage_key": "property/5675057267343360/019f14f0-2e7e-75be-813e-fb96fae8854a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northcharlestoncoliseumpac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4984177135569200452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-coliseum--performing-arts-center",
      "poi_latitude": "32.8654952",
      "poi_longitude": "-80.02243399999999",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-529-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bee7-7434-8f34-35c741525655",
        "storage_key": "property/5675057267343360/019f14ed-bee7-7434-8f34-35c741525655.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6YMfE5j_ogRROU5j7JaK0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_c1f5af29db29f0abe5e05967",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "HCA Healthcare Summerville Hospital, A part of Trident Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "295 Midland Pkwy, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-9f00-7179-b447-7c4689898f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-9f00-7179-b447-7c4689898f3c",
        "storage_key": "property/5675057267343360/019f14ed-9f00-7179-b447-7c4689898f3c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/summerville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709934292123430214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare-summerville-hospital-a-part-of-trident-hospital",
      "poi_latitude": "32.9657337",
      "poi_longitude": "-80.1575356",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-970-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef1-7201-a3af-93f7f037a684",
        "storage_key": "property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJzy_JxduL_ogRRq1yzUgMXUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_97b15e65ddaad4d378f671d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "generator",
      "poi_name": "Roper Hospital | Roper St. Francis Healthcare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "316 Calhoun St, Charleston, SC 29401, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14f0-a0a0-723f-ba02-ca7cb145e51a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-a0a0-723f-ba02-ca7cb145e51a",
        "storage_key": "property/5675057267343360/019f14f0-a0a0-723f-ba02-ca7cb145e51a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.rsfh.com/roper-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7916430448040606654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roper-hospital--roper-st-francis-healthcare",
      "poi_latitude": "32.7828329",
      "poi_longitude": "-79.9494575",
      "poi_miles_from_property": "33.5 mi",
      "poi_walking_minutes": "12 hours 8 mins",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 843-724-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-bef1-7201-a3af-93f7f037a684",
        "storage_key": "property/5675057267343360/019f14ed-bef1-7201-a3af-93f7f037a684.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcx7nTl6_ogRvvuLqIzP3G0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_9cde0cb7-0570-4118-9a7e-6af0a6b1635d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0cf7bcb1-d40a-40cc-885f-05b641ce0d15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4add8c1b-7e31-40f7-9ea6-5cae34dbcb66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_477fe411-363d-4d04-9ef1-aa68dab9d37d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9ae1b7cd-19ba-4676-aad2-1414c6dd12ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f614f023-17b6-4744-9bb2-594a8cdb7db5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a4f0002e35889cd80ecd2244",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "rating": "5",
      "name": "DAVID SIMMONS",
      "text": "Hello. I am in the process of trying to move in to the complex and Brooke and April have been amazing at taking my phone calls and responding to emails and answering my questions. Definitely have amazing people working there and look forward to hopefully moving in very soon! 😁😁😁",
      "date": "2026-05-28",
      "title": "false"
    },
    {
      "id": "ec_96c2876e69893448bfafb8a9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "rating": "5",
      "name": "Rachel Darling",
      "text": "We were touring apartments recently, and Ms. Keisha made the entire experience unforgettable. From the moment we walked in, she was incredibly sweet, welcoming, and so full of genuine joy. You can tell she truly loves what she does and cares about the people she’s helping. She took her time with us, answered every question, and made sure we felt comfortable and informed throughout the whole process.\n\nThe Mason itself is such a beautiful community. The pool is gorgeous, the amenities are impressive, and everything feels clean, modern, and well taken care of. But honestly, Ms. Keisha is what made us fall in love with the place. Her kindness and energy made us feel right at home before we even applied.\n\nIf you’re looking for an amazing place to live with people who truly care, The Mason is it. And if you get the chance to meet Ms. Keisha, you’re in the best hands possible.",
      "date": "2025-11-21",
      "title": "false"
    },
    {
      "id": "ec_61c47b3b5b80630ab85bbc46",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "rating": "5",
      "name": "Darvyn",
      "text": "Jenna,\n\nAmazing !!!  She cares about customer service.\n\nBrooke, April and Keisha\n\nHandled a challenging situation with class\nRespect and decorum..\n\nI really appreciate them really being fair and extremely professional.\n\nThe Mason has a staff that is all ⭐️ ✨\n\nThank you….",
      "date": "2026-03-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b2d7e32f-da12-4867-8fb0-511bc528390d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14c2-f514-7441-96e0-4719ad9c16e6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-f514-7441-96e0-4719ad9c16e6",
        "storage_key": "property/5675057267343360/019f14c2-f514-7441-96e0-4719ad9c16e6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,080SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=a2H6U2zewX7"
    },
    {
      "id": "custom_5f167d7c-7d82-4265-9c4a-07368c252663",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019d02f0-aab8-710a-a2c7-c68c72e47199.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and medicine balls.",
        "public_id": "019d02f0-aab8-710a-a2c7-c68c72e47199",
        "storage_key": "property/5675057267343360/019d02f0-aab8-710a-a2c7-c68c72e47199.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1PsNcSUyfqW"
    },
    {
      "id": "custom_b4d17060-f1a1-41c6-ae9a-73bde48ee9a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14c2-fb35-72dc-9966-b8e9ed1d361e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-fb35-72dc-9966-b8e9ed1d361e",
        "storage_key": "property/5675057267343360/019f14c2-fb35-72dc-9966-b8e9ed1d361e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iBVh2AhTUYN"
    },
    {
      "id": "custom_74e4fe2f-f415-4b74-8892-f2dfe3e282b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14c2-fba0-76fa-8182-cd25198e8eb5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-fba0-76fa-8182-cd25198e8eb5",
        "storage_key": "property/5675057267343360/019f14c2-fba0-76fa-8182-cd25198e8eb5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Movie Theater Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WHx4ZBg8dDN"
    },
    {
      "id": "custom_35e4c272-2088-4f91-81ba-18da511c5246",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019d02f0-ac4d-7180-98f1-6321dcf37ad1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Resort-style swimming pool and lounge area at a multifamily property.",
        "public_id": "019d02f0-ac4d-7180-98f1-6321dcf37ad1",
        "storage_key": "property/5675057267343360/019d02f0-ac4d-7180-98f1-6321dcf37ad1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pool 360",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EkKUG4ZAWJW"
    },
    {
      "id": "custom_efcdee43-8e97-4c0f-a846-9a2042afa6be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f14c2-f57c-717f-9cdf-5bfbf762a96e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-f57c-717f-9cdf-5bfbf762a96e",
        "storage_key": "property/5675057267343360/019f14c2-f57c-717f-9cdf-5bfbf762a96e.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Mason - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/wyPxd7YuaaM"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-4d9e-7679-ae5d-486c678e6edd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-mason",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360"
    },
    {
      "lead_collector_id": "0198aa46-4e01-74ab-a577-783865cfadac",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-mason",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360"
    },
    {
      "lead_collector_id": "0198aa46-4e68-76a6-b749-08a59e594168",
      "lead_source": "LANDING_PAGE",
      "name": "the-mason",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "discover-studio-apartments-for-rent-in-ladson-sc",
      "search_query": "Studio Apartments For Rent In Ladson SC",
      "category": "Floorplan",
      "h1_title": "Discover Studio Apartments For Rent in Ladson, SC at The Mason",
      "h2_subtitle": "Experience luxury living with our studio apartments in Ladson, SC. Enjoy modern amenities and a convenient location near Charleston Southern University.",
      "page_copy": "The Mason offers an exceptional selection of studio apartments for rent in Ladson, SC, designed to elevate your lifestyle. Each apartment features high-end finishes, including stainless steel appliances and granite countertops, ensuring a sophisticated living experience. Our pet-friendly community is perfect for those who value convenience and style, with in-unit washers and dryers to simplify your daily routine.\n\nBeyond your apartment, The Mason provides a range of amenities to enhance your living experience. Stay active in our 24-hour fitness center or unwind by the resort-style swimming pool with cabanas. The clubhouse with a cyber cafe offers a perfect spot for relaxation or remote work. Located near Charleston Southern University, The Mason is the ideal place to call home for those seeking studio apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Studio Apartments For Rent in Ladson, SC",
      "seo_description": "Explore The Mason's studio apartments for rent in Ladson, SC. Enjoy luxury living with modern amenities near Charleston Southern University.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "explore-one-bedroom-apartments-for-rent-in-ladson-sc",
      "search_query": "One Bedroom Apartments For Rent In Ladson SC",
      "category": "Floorplan",
      "h1_title": "Explore One Bedroom Apartments For Rent in Ladson, SC at The Mason",
      "h2_subtitle": "Find your perfect one bedroom apartment in Ladson, SC, at The Mason. Enjoy modern amenities and a prime location near Charleston Southern University.",
      "page_copy": "The Mason presents an exquisite selection of one bedroom apartments for rent in Ladson, SC, tailored for those who appreciate modern living. Each apartment features upscale amenities, including stainless steel appliances and granite countertops, providing a stylish and comfortable home. Our pet-friendly community ensures convenience with in-unit washers and dryers, allowing you to focus on what truly matters.\n\nAt The Mason, you'll find a variety of amenities designed to enhance your lifestyle. Maintain your fitness routine in our 24-hour fitness center or relax by the resort-style swimming pool with cabanas. The clubhouse with a cyber cafe offers a perfect space for socializing or working remotely. Located near Charleston Southern University, The Mason is the ideal choice for those seeking one bedroom apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | One Bedroom Apartments For Rent in Ladson, SC",
      "seo_description": "Discover The Mason's one bedroom apartments for rent in Ladson, SC. Enjoy luxury living with modern amenities near Charleston Southern University.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-two-bedrooms-apartments-for-rent-in-ladson-sc",
      "search_query": "Two Bedrooms Apartments For Rent In Ladson SC",
      "category": "Floorplan",
      "h1_title": "Find Two Bedroom Apartments For Rent in Ladson, SC at The Mason",
      "h2_subtitle": "Discover spacious two bedroom apartments in Ladson, SC, at The Mason. Enjoy luxury amenities and a convenient location near Charleston Southern University.",
      "page_copy": "The Mason offers an impressive selection of two bedroom apartments for rent in Ladson, SC, perfect for those seeking space and style. Each apartment features modern amenities, including stainless steel appliances and granite countertops, ensuring a luxurious living environment. Our pet-friendly community is designed for convenience, with in-unit washers and dryers to simplify your daily tasks.\n\nEnhance your lifestyle with The Mason's exceptional amenities. Stay fit in our 24-hour fitness center or unwind by the resort-style swimming pool with cabanas. The clubhouse with a cyber cafe provides an ideal setting for relaxation or remote work. Situated near Charleston Southern University, The Mason is the perfect choice for those looking for two bedroom apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Two Bedroom Apartments For Rent in Ladson, SC",
      "seo_description": "Explore The Mason's two bedroom apartments for rent in Ladson, SC. Enjoy luxury living with modern amenities near Charleston Southern University.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Pool at The Mason",
      "h2_subtitle": "Enjoy luxury living with a resort-style pool at The Mason in Ladson, SC. Our community offers modern amenities and a prime location near Charleston Southern University.",
      "page_copy": "The Mason is your destination for apartments for rent near you with a pool, offering a luxurious lifestyle in Ladson, SC. Our community features a stunning resort-style swimming pool with cabanas, perfect for relaxation and socializing. Whether you're looking for a studio, one, or two-bedroom apartment, The Mason provides high-end amenities like stainless steel appliances and granite countertops to enhance your living experience.\n\nBeyond the pool, The Mason offers a variety of amenities to suit your lifestyle. Stay active in our 24-hour fitness center or enjoy the clubhouse with a cyber cafe. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Charleston Southern University, The Mason is the ideal choice for those seeking apartments for rent with a pool.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore The Mason's apartments for rent with a pool in Ladson, SC. Enjoy luxury living with modern amenities and a resort-style pool today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near You with a Fitness Center at The Mason",
      "h2_subtitle": "Experience modern living with a 24-hour fitness center at The Mason in Ladson, SC. Enjoy top-tier amenities and a convenient location near Charleston Southern University.",
      "page_copy": "The Mason is the perfect choice for those seeking apartments for rent near you with a fitness center in Ladson, SC. Our community features a state-of-the-art 24-hour fitness center, allowing you to maintain your active lifestyle at your convenience. Choose from our studio, one, or two-bedroom apartments, each equipped with high-end amenities like stainless steel appliances and granite countertops.\n\nIn addition to the fitness center, The Mason offers a variety of amenities to enhance your living experience. Relax by the resort-style swimming pool with cabanas or enjoy the clubhouse with a cyber cafe. Our pet-friendly community also includes a dog park and walking trails, making it ideal for all residents. Located near Charleston Southern University, The Mason is the ideal destination for apartments for rent near you with a fitness center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Discover The Mason's apartments for rent near you with a fitness center in Ladson, SC. Enjoy luxury living with modern amenities and a 24-hour fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-clubhouse-mason",
      "search_query": "Apartments For Rent Near Me with Clubhouse",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Clubhouse at The Mason",
      "h2_subtitle": "Enjoy luxury living with a modern clubhouse at The Mason in Ladson, SC. Our community offers top-notch amenities and a prime location near Charleston Southern University.",
      "page_copy": "The Mason is your ideal destination for apartments for rent with a clubhouse in Ladson, SC. Our community features a contemporary clubhouse with a cyber cafe, perfect for socializing or working remotely. Choose from our studio, one, or two-bedroom apartments, each designed with high-end amenities like stainless steel appliances and granite countertops to enhance your living experience.\n\nBeyond the clubhouse, The Mason offers a variety of amenities to suit your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Charleston Southern University, The Mason is the perfect choice for those seeking apartments for rent with a clubhouse.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments For Rent Near Me with Clubhouse",
      "seo_description": "Explore The Mason's apartments for rent with a clubhouse in Ladson, SC. Enjoy luxury living with modern amenities and a stylish clubhouse today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-lounge",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near You with a Lounge at The Mason",
      "h2_subtitle": "Experience luxury living with a stylish lounge at The Mason in Ladson, SC. Enjoy modern amenities and a convenient location near Charleston Southern University.",
      "page_copy": "The Mason is the perfect choice for those seeking apartments for rent near you with a lounge in Ladson, SC. Our community features a sophisticated lounge area, ideal for relaxation and social gatherings. Choose from our studio, one, or two-bedroom apartments, each equipped with high-end amenities like stainless steel appliances and granite countertops to elevate your living experience.\n\nIn addition to the lounge, The Mason offers a variety of amenities to enhance your lifestyle. Unwind by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, making it a welcoming environment for all residents. Located near Charleston Southern University, The Mason is the ideal destination for apartments for rent near you with a lounge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments For Rent Near Me with Lounge",
      "seo_description": "Discover The Mason's apartments for rent with a lounge in Ladson, SC. Enjoy luxury living with modern amenities near Charleston Southern University.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-storage-space",
      "search_query": "Apartments For Rent Near Me with Storage Space",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near You with Storage Space at The Mason",
      "h2_subtitle": "Enjoy spacious living with ample storage space at The Mason in Ladson, SC. Our community offers modern amenities and a prime location near Charleston Southern University.",
      "page_copy": "The Mason is your ideal destination for apartments for rent near you with storage space in Ladson, SC. Our apartments are designed with ample storage solutions, including walk-in closets and linen closets, to keep your living space organized and clutter-free. Choose from our studio, one, or two-bedroom floor plans, each featuring high-end amenities like stainless steel appliances and granite countertops.\n\nBeyond storage space, The Mason offers a variety of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Charleston Southern University, The Mason is the perfect choice for those seeking apartments for rent with storage space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments For Rent Near Me with Storage Space",
      "seo_description": "Discover The Mason's apartments for rent with storage space in Ladson, SC. Enjoy luxury living with modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-granite-countertops",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with Granite Countertops at The Mason",
      "h2_subtitle": "Experience luxury living with elegant granite countertops at The Mason in Ladson, SC. Enjoy modern amenities and a convenient location near Charleston Southern University.",
      "page_copy": "The Mason is the perfect choice for those seeking apartments for rent with granite countertops in Ladson, SC. Our apartments feature chef-worthy kitchens with sleek granite countertops, providing a stylish and functional space for cooking and entertaining. Choose from our studio, one, or two-bedroom floor plans, each designed with high-end finishes and modern conveniences.\n\nBeyond the granite countertops, The Mason offers a variety of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Charleston Southern University, The Mason is the ideal destination for apartments for rent with granite countertops.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments Near Me with Granite Countertops",
      "seo_description": "Explore The Mason's apartments for rent with granite countertops in Ladson, SC. Enjoy luxury living with modern amenities near CSU.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near You with Stainless Steel Appliances at The Mason",
      "h2_subtitle": "Enjoy modern living with sleek stainless steel appliances at The Mason in Ladson, SC. Our community offers high-end amenities and a prime location near Charleston Southern University.",
      "page_copy": "The Mason is your ideal destination for apartments for rent with stainless steel appliances in Ladson, SC. Our apartments feature chef-worthy kitchens equipped with sleek stainless steel appliances, providing a modern and efficient cooking experience. Choose from our studio, one, or two-bedroom floor plans, each designed with high-end finishes and conveniences to enhance your lifestyle.\n\nBeyond the stainless steel appliances, The Mason offers a variety of amenities to suit your needs. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Charleston Southern University, The Mason is the perfect choice for those seeking apartments for rent with stainless steel appliances.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments Near Me with Stainless Steel Appliances",
      "seo_description": "Discover The Mason's apartments for rent  with stainless steel appliances in Ladson, SC. Enjoy luxury living with modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-island-kitchen",
      "search_query": "Apartments For Rent Near Me with Island Kitchen",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with Kitchen Islands at The Mason",
      "h2_subtitle": "Experience luxury living with spacious kitchen islands at The Mason in Ladson, SC. Enjoy modern amenities and a convenient location near Charleston Southern University.",
      "page_copy": "The Mason is the perfect choice for those seeking apartments for rent with kitchen islands in Ladson, SC. Our apartments feature spacious kitchen islands, ideal for cooking and entertaining, equipped with sleek stainless steel appliances and granite countertops. Choose from our studio, one, or two-bedroom floor plans, each designed to enhance your living experience with high-end finishes and modern conveniences.\n\nBeyond the kitchen islands, The Mason offers a variety of amenities to suit your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Charleston Southern University, The Mason is the ideal destination for apartments for rent with kitchen islands.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments For Rent Near Me with Kitchen Island",
      "seo_description": "Explore The Mason's apartments for rent with kitchen islands in Ladson, SC. Enjoy luxury living with modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-rush-university",
      "search_query": "Apartments For Rent In Ladson SC Near RUSH University Medical Center",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent in Ladson, SC Near RUSH University Medical Center",
      "h2_subtitle": "Discover luxury living at The Mason, offering modern apartments near RUSH University Medical Center. Enjoy high-end amenities and a convenient location in Ladson, SC.",
      "page_copy": "The Mason is your ideal choice for apartments for rent in Ladson, SC near RUSH University Medical Center. Our community offers brand-new studio, one, and two-bedroom homes equipped with high-end amenities like stainless steel appliances and granite countertops. Each apartment is designed for modern living, featuring chef-worthy kitchens and in-unit washers and dryers for your convenience.\n\nBeyond the apartments, The Mason provides a range of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near RUSH University Medical Center, The Mason is the perfect destination for those seeking apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Ladson, SC Near RUSH University Medical Center",
      "seo_description": "Discover The Mason's apartments for rent in Ladson, SC near RUSH University Medical Center. Enjoy luxury living with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-in-ladson-sc-near-uchicago",
      "search_query": "Apartments For Rent In Ladson SC Near UChicago Medicine",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent in Ladson, SC Near UChicago Medicine at The Mason",
      "h2_subtitle": "Discover luxury living at The Mason, offering modern apartments near UChicago Medicine. Enjoy high-end amenities and a convenient location in Ladson, SC.",
      "page_copy": "The Mason is your ideal choice for apartments for rent in Ladson, SC near UChicago Medicine. Our community offers brand-new studio, one, and two-bedroom homes equipped with high-end amenities like stainless steel appliances and granite countertops. Each apartment is designed for modern living, featuring chef-worthy kitchens and in-unit washers and dryers for your convenience.\n\nBeyond the apartments, The Mason provides a range of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near UChicago Medicine, The Mason is the perfect destination for those seeking apartments for rent in Ladson SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments For Rent in Ladson, SC Near UChicago Medicine",
      "seo_description": "Discover The Mason's apartments for rent in Ladson, SC near UChicago Medicine. Enjoy luxury living with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-ladson-sc-near-northwestern",
      "search_query": "Apartments For Rent In Ladson SC Near Northwestern University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Ladson, SC Near Northwestern University at The Mason",
      "h2_subtitle": "Experience luxury living at The Mason, offering modern apartments near Northwestern University. Enjoy high-end amenities and a convenient location in Ladson, SC.",
      "page_copy": "The Mason is your ideal choice for apartments for rent in Ladson, SC near Northwestern University. Our community offers brand-new studio, one, and two-bedroom homes equipped with high-end amenities like stainless steel appliances and granite countertops. Each apartment is designed for modern living, featuring chef-worthy kitchens and in-unit washers and dryers for your convenience.\n\nBeyond the apartments, The Mason provides a range of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Northwestern University, The Mason is the perfect destination for those seeking apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Ladson, SC Near Northwestern University",
      "seo_description": "Discover The Mason's apartments for rent in Ladson, SC near Northwestern University. Enjoy luxury living with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-in-ladson-sc-near-iit",
      "search_query": "Apartments For Rent In Ladson SC Near Illinois Institute of Technology",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent in Ladson, SC Near Illinois Institute of Technology at The Mason",
      "h2_subtitle": "Discover luxury living at The Mason, offering modern apartments near Illinois Institute of Technology. Enjoy high-end amenities and a convenient location in Ladson, SC.",
      "page_copy": "The Mason is your ideal choice for apartments for rent in Ladson, SC near Illinois Institute of Technology. Our community offers brand-new studio, one, and two-bedroom homes equipped with high-end amenities like stainless steel appliances and granite countertops. Each apartment is designed for modern living, featuring chef-worthy kitchens and in-unit washers and dryers for your convenience.\n\nBeyond the apartments, The Mason provides a range of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near Illinois Institute of Technology, The Mason is the perfect destination for those seeking apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments Near Illinois Institute of Technology",
      "seo_description": "Discover The Mason's apartments in Ladson, SC near Illinois Institute of Technology. Enjoy luxury living with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-depaul-university-lincoln-park",
      "search_query": "Apartments For Rent In Ladson SC Near DePaul University - Lincoln Park Student Center",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Ladson, SC Near DePaul University at The Mason",
      "h2_subtitle": "Experience luxury living at The Mason, offering modern apartments near DePaul University. Enjoy high-end amenities in Ladson, SC.",
      "page_copy": "The Mason is your ideal choice for apartments for rent in Ladson, SC near DePaul University. Our community offers brand-new studio, one, and two-bedroom homes equipped with high-end amenities like stainless steel appliances and granite countertops. Each apartment is designed for modern living, featuring chef-worthy kitchens and in-unit washers and dryers for your convenience.\n\nBeyond the apartments, The Mason provides a range of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near DePaul University, The Mason is the perfect destination for those seeking apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments For Rent in Ladson, SC Near DePaul University",
      "seo_description": "Discover The Mason's apartments for rent in Ladson, SC near DePaul University. Enjoy luxury living with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-ladson-sc-near-uic",
      "search_query": "Apartments For Rent In Ladson SC Near UIC School of Public Health",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Ladson, SC Near UIC School of Public Health at The Mason",
      "h2_subtitle": "Experience luxury living at The Mason, offering modern apartments near UIC School of Public Health. Enjoy high-end amenities and a convenient location in Ladson, SC.",
      "page_copy": "The Mason is your ideal choice for apartments for rent in Ladson, SC near UIC School of Public Health. Our community offers brand-new studio, one, and two-bedroom homes equipped with high-end amenities like stainless steel appliances and granite countertops. Each apartment is designed for modern living, featuring chef-worthy kitchens and in-unit washers and dryers for your convenience.\n\nBeyond the apartments, The Mason provides a range of amenities to enhance your lifestyle. Relax by the resort-style swimming pool with cabanas or stay active in our 24-hour fitness center. Our pet-friendly community also includes a dog park and walking trails, ensuring every resident feels at home. Located near UIC School of Public Health, The Mason is the perfect destination for those seeking apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Ladson, SC Near UIC School of Public Health",
      "seo_description": "Discover The Mason's apartments for rent in Ladson, SC near UIC School of Public Health. Enjoy luxury living with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-ladson-elementary",
      "search_query": "Apartments For Rent In Ladson SC Near Ladson Elementary School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Ladson, SC Near Ladson Elementary School at The Mason",
      "h2_subtitle": "Enjoy family-friendly living at The Mason, offering modern apartments near Ladson Elementary School. Explore our spacious floor plans and top-notch amenities.",
      "page_copy": "The Mason is the perfect choice for families seeking apartments for rent in Ladson SC near Ladson Elementary School. Our community offers convenient access to quality education within the Charleston County School District. Choose from our studio, one, and two-bedroom floor plans, each designed with high-end amenities like stainless steel appliances and granite countertops to enhance your family's living experience.\n\nBeyond the proximity to Ladson Elementary School, The Mason provides a range of amenities to suit your family's lifestyle. Relax by the resort-style swimming pool with cabanas or enjoy the playground and walking trails. Our pet-friendly community also includes a dog park, ensuring every member of your family feels at home. The Mason is the ideal destination for families looking for apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Mason | Apartments in Ladson, SC Near Ladson Elementary",
      "seo_description": "Explore The Mason's family-friendly apartments for rent in Ladson, SC near Ladson Elementary School. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-ladson-sc-near-sangaree",
      "search_query": "Apartments For Rent In Ladson SC Near Sangaree Middle School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Ladson, SC Near Sangaree Middle School at The Mason",
      "h2_subtitle": "Enjoy family-friendly living at The Mason, offering modern apartments near Sangaree Middle School. Explore our spacious floor plans and top-notch amenities.",
      "page_copy": "The Mason is the ideal choice for families seeking apartments for rent in Ladson, SC near Sangaree Middle School. Our community provides convenient access to quality education within the Berkeley County School District. Choose from our studio, one, and two-bedroom floor plans, each designed with high-end amenities like stainless steel appliances and granite countertops to enhance your family's living experience.\n\nBeyond the proximity to Sangaree Middle School, The Mason offers a range of amenities to suit your family's lifestyle. Relax by the resort-style swimming pool with cabanas or enjoy the playground and walking trails. Our pet-friendly community also includes a dog park, ensuring every member of your family feels at home. The Mason is the perfect destination for families looking for apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Ladson, SC Near Sangaree Middle School",
      "seo_description": "Explore The Mason's family-friendly apartments for rent in Ladson, SC near Sangaree Middle School. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5675057267343360",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-ladson-sc-near-deer-park",
      "search_query": "Apartments For Rent In Ladson SC Near Deer Park Middle School",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent in Ladson, SC Near Deer Park Middle School at The Mason",
      "h2_subtitle": "Enjoy family-friendly living at The Mason, offering modern apartments near Deer Park Middle School. Discover our spacious floor plans and top-notch amenities.",
      "page_copy": "The Mason is the perfect choice for families seeking apartments for rent in Ladson, SC near Deer Park Middle School. Our community offers convenient access to quality education. Choose from our studio, one, and two-bedroom floor plans, each designed with high-end amenities like stainless steel appliances and granite countertops to enhance your family's living experience.\n\nBeyond the proximity to Deer Park Middle School, The Mason provides a range of amenities to suit your family's lifestyle. Relax by the resort-style swimming pool with cabanas or enjoy the playground and walking trails. Our pet-friendly community also includes a dog park, ensuring every member of your family feels at home. The Mason is the ideal destination for families looking for apartments for rent in Ladson, SC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with pool, playground, and walking paths",
        "public_id": "019f6c13-3e84-76dc-8582-f1d1cd647576",
        "storage_key": "property/5675057267343360/019f6c13-3e84-76dc-8582-f1d1cd647576.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
      "blank_image_media": {
        "alt_text": "Black screen",
        "public_id": "019f6c13-4714-72be-afd4-e46306d1fe10",
        "storage_key": "property/5675057267343360/019f6c13-4714-72be-afd4-e46306d1fe10.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Ladson Near Deer Park Middle School",
      "seo_description": "Discover The Mason's family-friendly apartments for rent in Ladson, SC near Deer Park Middle School. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2214"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471526"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a61\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a61\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4786612"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NNMGXLJ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443209788"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f110768362d31311"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/e8ywkjzqplx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/8562c114-2f58-4ff3-b62f-a36fabb31907"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "854-230-4905"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik0yRElBNmQyVGU0czB3RGkwc0t0OVE9PSIsInZhbHVlIjoiVnRCSnUrTkQwYUkzazhaK2dFL0toQT09IiwibWFjIjoiYzZhNDMzNzRmOGQxZTkyNTQ2ZmE2MTgyMzg2OWNmMDRjNDc2YmI4Y2UzNWMyMTA1NDc4NzFkMzE5NzVlODBmNiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2214",
  "custom_repli_id": "2376471526",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a61\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a61\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4786612",
  "custom_google_gtm_id": "GTM-NNMGXLJ",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443209788",
  "custom_knock_community_id": "f110768362d31311",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/e8ywkjzqplx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/8562c114-2f58-4ff3-b62f-a36fabb31907",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "854-230-4905",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik0yRElBNmQyVGU0czB3RGkwc0t0OVE9PSIsInZhbHVlIjoiVnRCSnUrTkQwYUkzazhaK2dFL0toQT09IiwibWFjIjoiYzZhNDMzNzRmOGQxZTkyNTQ2ZmE2MTgyMzg2OWNmMDRjNDc2YmI4Y2UzNWMyMTA1NDc4NzFkMzE5NzVlODBmNiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "bee1398b-052a-4005-b8d4-a3db4c1e3e94",
  "custom_audioeye_site_hash": "318dd81eb4317af4fb5e8ebc21939f0b"
};

export const generatedAt = '2026-11-03T20:29:21.237Z';
